/* GleamCanvas Design Studio: visitors sketch a kit idea and send it to the studio.
   Shared by the preview site and the Shopify theme. tools/build-theme-js.js copies this
   file to shopify-theme/assets/design-studio.js, so edit it here only.
   Submissions go to Forminit (https://forminit.com) using its fi-* field names.

   The preview hoop is an interactive canvas: kit shape + colors + surface pattern (form),
   a scene behind the kit, draggable stickers and words, and freehand drawing (toolbox).

   Container attributes:
     data-form-id         Forminit form ID (blank = not connected yet)
     data-mode            "preview" (site/ demo: nothing is sent) or "live" (Shopify)
     data-community-url   design-circle link shown after sending
     data-consent         consent checkbox wording
     data-thanks-heading / data-thanks-text   success message */
(function () {
  "use strict";
  var root = document.querySelector("[data-design-studio]");
  if (!root) return;
  var NS = "http://www.w3.org/2000/svg";

  var attr = function (n, d) { var v = root.getAttribute(n); return v == null || v === "" ? d : v; };
  var cfg = {
    formId: attr("data-form-id", ""),
    mode: attr("data-mode", "live"),
    community: attr("data-community-url", ""),
    consent: attr("data-consent", "I confirm this idea and any images I upload are my own, and GleamCanvas may use them to develop new kits."),
    thanksHeading: attr("data-thanks-heading", "Your design is on its way!"),
    thanksText: attr("data-thanks-text", "Thank you for sharing your idea with the GleamCanvas studio. Our team looks at every design from our community."),
    // 3D view (loaded only when a visitor switches to 3D)
    d3Src: attr("data-3d-src", "assets/js/design-3d.js"),
    threeSrc: attr("data-three-src", "assets/js/vendor/three.min.js")
  };
  // Preview site only: ?formId=... sends real test submissions before the Shopify theme is live.
  if (cfg.mode === "preview" && !cfg.formId) {
    try { cfg.formId = new URLSearchParams(location.search).get("formId") || ""; } catch (e) {}
  }
  var ENDPOINT = "https://forminit.com/f/";
  var DRAFT_KEY = "gc_design_draft";
  var MAX_PHOTOS = 3;
  var MAX_TOTAL = 20 * 1024 * 1024; // Forminit allows 25 MB per submission
  var MAX_STICKERS = 30, MAX_STROKES = 80, MAX_PTS = 600, MAX_TEXT = 18;

  /* ---------- Options ---------- */
  var KITS = [
    { id: "house", label: "Holiday house", hint: "Cottages & cabins" },
    { id: "tree", label: "Spinning tree", hint: "Trees that turn" },
    { id: "ornament", label: "Ornament", hint: "Hang on the tree" },
    { id: "lantern", label: "Lantern", hint: "Tabletop glow" },
    { id: "coaster", label: "Coaster set", hint: "With a holder" },
    { id: "cupcake", label: "Cupcake stand", hint: "Tiered treats" },
    { id: "other", label: "Something new", hint: "Surprise us!" }
  ];
  var PALETTES = [
    { id: "winter", name: "Winter Wonderland", c: ["#22607f", "#b4c8d2", "#ffffff"] },
    { id: "candy", name: "Candy Cane", c: ["#d63c4f", "#f07cae", "#ffffff"] },
    { id: "evergreen", name: "Evergreen", c: ["#2f7a4f", "#c0392b", "#ffc857"] },
    { id: "pumpkin", name: "Pumpkin Spice", c: ["#e07b39", "#6b4430", "#ffc857"] },
    { id: "garden", name: "Spring Garden", c: ["#f4a3c0", "#7fc29b", "#fff3d6"] },
    { id: "ocean", name: "Ocean Breeze", c: ["#3aa6c9", "#22607f", "#e6eef2"] },
    { id: "lavender", name: "Lavender Dream", c: ["#9b7ede", "#f07cae", "#fdf6ff"] }
  ];
  var OCCASIONS = ["Christmas", "Halloween", "Easter", "Valentine's Day", "Spring & summer", "Autumn", "Everyday", "Birthday"];
  var EXTRAS = [
    { id: "lights", label: "Lights up", hint: "A little glow inside" },
    { id: "moving", label: "Moving parts", hint: "Spins, rolls or rings" },
    { id: "beginner", label: "Easy build", hint: "Great for beginners" }
  ];
  var PATTERNS = [["plain", "Plain"], ["stripes", "Stripes"], ["polka", "Polka dots"], ["checks", "Checks"], ["bricks", "Bricks"], ["hearts", "Hearts"]];
  var SKIES = [["none", "None"], ["day", "Daytime"], ["night", "Starry night"], ["sunset", "Sunset"]];
  var GROUNDS = [["none", "None"], ["snow", "Snow"], ["grass", "Grass"], ["sand", "Sand"], ["water", "Water"]];
  var FALLING = [["none", "None"], ["snow", "Snowfall"], ["sparkles", "Sparkles"], ["hearts", "Hearts"]];
  var FONTS = { script: ["Script", "Sacramento, cursive", 400], rounded: ["Rounded", "Fredoka, Nunito, sans-serif", 600], serif: ["Serif", "'Playfair Display', Georgia, serif", 600] };
  var SIZES = [["s", "Thin", 4], ["m", "Medium", 8], ["l", "Thick", 14]];
  var EXTRA_SWATCHES = ["#123447", "#ffffff", "#d63c4f", "#f07cae", "#ffc857", "#2f7a4f", "#3aa6c9", "#9b7ede", "#8a5a3b"];

  // Sticker art lives in a 40×40 box; {c} is the tintable color.
  var STICKERS = [
    { id: "star", label: "Star", group: "Shapes & sweets", tint: "#ffc857", svg: '<path d="M20 3l4.6 10.2 11 1.2-8.2 7.5 2.3 11L20 27.4 10.3 33l2.3-11L4.4 14.4l11-1.2z" fill="{c}"/>' },
    { id: "heart", label: "Heart", group: "Shapes & sweets", tint: "#f07cae", svg: '<path d="M20 35S4 24 4 13a8 8 0 0 1 16-3 8 8 0 0 1 16 3c0 11-16 22-16 22z" fill="{c}"/>' },
    { id: "sparkle", label: "Sparkle", group: "Shapes & sweets", tint: "#ffc857", svg: '<path d="M20 2c1.5 10 7 15.5 17 18-10 2.5-15.5 8-17 18-1.5-10-7-15.5-17-18C13 17.5 18.5 12 20 2z" fill="{c}"/>' },
    { id: "rainbow", label: "Rainbow", group: "Shapes & sweets", tint: "#d63c4f", svg: '<g fill="none" stroke-width="4" stroke-linecap="round"><path d="M4 32a16 16 0 0 1 32 0" stroke="{c}"/><path d="M9 32a11 11 0 0 1 22 0" stroke="#ffc857"/><path d="M14 32a6 6 0 0 1 12 0" stroke="#3aa6c9"/></g>' },
    { id: "cupcake", label: "Cupcake", group: "Shapes & sweets", tint: "#f07cae", svg: '<path d="M9 20h22l-3 16H12z" fill="{c}"/><path d="M10 20c0-9 5-13 10-13s10 4 10 13z" fill="#fde4ef"/><path d="M10 21h20" stroke="#fde4ef" stroke-width="5" stroke-linecap="round"/><circle cx="20" cy="7" r="2.5" fill="#d63c4f"/>' },
    { id: "gift", label: "Gift", group: "Shapes & sweets", tint: "#f07cae", svg: '<rect x="6" y="16" width="28" height="20" rx="2" fill="{c}"/><rect x="4" y="11" width="32" height="7" rx="2" fill="{c}"/><path d="M18 11v25M22 11v25M4 15h32" stroke="#ffc857" stroke-width="3"/><path d="M20 11c-6-1-9-5-6-7s6 3 6 7zm0 0c6-1 9-5 6-7s-6 3-6 7z" fill="#ffc857"/>' },
    { id: "bow", label: "Bow", group: "Shapes & sweets", tint: "#f07cae", svg: '<path d="M20 20L6 12v16zM20 20l14-8v16z" fill="{c}"/><circle cx="20" cy="20" r="4" fill="{c}" stroke="#fff" stroke-width="1.5"/><path d="M17 23l-4 12M23 23l4 12" stroke="{c}" stroke-width="3.5" stroke-linecap="round"/>' },
    { id: "note", label: "Music note", group: "Shapes & sweets", tint: "#123447", svg: '<path d="M16 30V8l16-4v20" fill="none" stroke="{c}" stroke-width="3.5" stroke-linejoin="round"/><ellipse cx="12" cy="30" rx="5" ry="4" fill="{c}"/><ellipse cx="28" cy="26" rx="5" ry="4" fill="{c}"/>' },
    { id: "wreath", label: "Wreath", group: "Holidays", tint: "#d63c4f", svg: '<circle cx="20" cy="20" r="11" fill="none" stroke="#2f7a4f" stroke-width="7"/><circle cx="20" cy="20" r="11" fill="none" stroke="#3f9a63" stroke-width="3" stroke-dasharray="3 5"/><circle cx="12" cy="15" r="1.8" fill="{c}"/><circle cx="27" cy="13" r="1.8" fill="{c}"/><circle cx="30" cy="24" r="1.8" fill="{c}"/><circle cx="17" cy="30" r="1.8" fill="{c}"/><path d="M20 30l-4 5 4-1 4 1zM15 30h10l-1-3h-8z" fill="{c}"/>' },
    { id: "candy", label: "Candy cane", group: "Holidays", tint: "#d63c4f", svg: '<path d="M14 36V12a6 6 0 0 1 12 0v2" fill="none" stroke="#fff" stroke-width="6" stroke-linecap="round"/><path d="M14 36V12a6 6 0 0 1 12 0v2" fill="none" stroke="{c}" stroke-width="6" stroke-linecap="round" stroke-dasharray="4 4"/>' },
    { id: "bell", label: "Bell", group: "Holidays", tint: "#ffc857", svg: '<path d="M12 26c0-10 2-18 8-18s8 8 8 18z" fill="{c}"/><rect x="9" y="25" width="22" height="4" rx="2" fill="{c}"/><circle cx="20" cy="32" r="3" fill="#b8860b"/><path d="M20 5v3" stroke="#b8860b" stroke-width="2.5" stroke-linecap="round"/>' },
    { id: "lights", label: "String lights", group: "Holidays", tint: "#d63c4f", svg: '<path d="M2 10q9 10 18 0t18 0" fill="none" stroke="#123447" stroke-width="1.6"/><circle cx="8" cy="19" r="3" fill="{c}"/><circle cx="14" cy="21" r="3" fill="#2f7a4f"/><circle cx="20" cy="18" r="3" fill="#ffc857"/><circle cx="26" cy="21" r="3" fill="#f07cae"/><circle cx="32" cy="19" r="3" fill="#3aa6c9"/>' },
    { id: "snowman", label: "Snowman", group: "Holidays", tint: "#d63c4f", svg: '<circle cx="20" cy="27" r="10" fill="#fff" stroke="#c9d6de"/><circle cx="20" cy="12" r="7" fill="#fff" stroke="#c9d6de"/><circle cx="17.5" cy="10.5" r="1" fill="#123447"/><circle cx="22.5" cy="10.5" r="1" fill="#123447"/><path d="M20 12.5l4 1-4 1z" fill="#ff8c42"/><circle cx="20" cy="24" r="1.2" fill="#123447"/><circle cx="20" cy="29" r="1.2" fill="#123447"/><path d="M13 17.5h14" stroke="{c}" stroke-width="3" stroke-linecap="round"/><path d="M14 4h12v3H14zM16 1h8v3h-8z" fill="#123447"/>' },
    { id: "snowflake", label: "Snowflake", group: "Holidays", tint: "#9fd3ea", svg: '<g stroke="{c}" stroke-width="2.6" stroke-linecap="round" fill="none"><path d="M20 3v34M5.3 11.5l29.4 17M5.3 28.5l29.4-17"/><path d="M20 3l-4 4m4-4l4 4M20 37l-4-4m4 4l4-4M5.3 11.5l5.5-1.4M5.3 11.5l1.4 5.5M34.7 28.5l-5.5 1.4m5.5-1.4l-1.4-5.5M5.3 28.5l5.5 1.4m-5.5-1.4l1.4-5.5M34.7 11.5l-5.5-1.4m5.5 1.4l-1.4 5.5"/></g>' },
    { id: "pine", label: "Pine tree", group: "Holidays", tint: "#2f7a4f", svg: '<polygon points="20,3 8,18 32,18" fill="{c}"/><polygon points="20,10 5,30 35,30" fill="{c}"/><rect x="17" y="30" width="6" height="7" fill="#8a5a3b"/>' },
    { id: "pumpkin", label: "Pumpkin", group: "Holidays", tint: "#e07b39", svg: '<ellipse cx="20" cy="24" rx="15" ry="12" fill="{c}"/><ellipse cx="13" cy="24" rx="6" ry="12" fill="#000" opacity=".12"/><ellipse cx="27" cy="24" rx="6" ry="12" fill="#000" opacity=".12"/><path d="M20 12c0-4 2-6 4-7" stroke="#2f7a4f" stroke-width="3" stroke-linecap="round" fill="none"/>' },
    { id: "ghost", label: "Ghost", group: "Holidays", tint: "#ffffff", svg: '<path d="M8 36V18a12 12 0 0 1 24 0v18l-4-3-4 3-4-3-4 3-4-3z" fill="{c}" stroke="#c9d6de"/><circle cx="16" cy="18" r="2" fill="#123447"/><circle cx="24" cy="18" r="2" fill="#123447"/>' },
    { id: "egg", label: "Easter egg", group: "Holidays", tint: "#9b7ede", svg: '<path d="M20 3c8 0 13 10 13 19a13 13 0 0 1-26 0C7 13 12 3 20 3z" fill="{c}"/><path d="M8 18q6 4 12 0t12 0M9 26q5.5 4 11 0t11 0" stroke="#fff" stroke-width="2.5" fill="none"/>' },
    { id: "cat", label: "Cat", group: "Nature & friends", tint: "#6b4f3a", svg: '<path d="M12 10l-2-7 6 4h8l6-4-2 7a10 10 0 0 1 2 6v8a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8v-8a10 10 0 0 1 2-6z" fill="{c}"/><path d="M28 24c6-2 8 4 4 8" stroke="{c}" stroke-width="3" fill="none" stroke-linecap="round"/><circle cx="16.5" cy="17" r="1.4" fill="#fff"/><circle cx="23.5" cy="17" r="1.4" fill="#fff"/><path d="M18.5 21h3l-1.5 1.5z" fill="#f07cae"/>' },
    { id: "bunny", label: "Bunny", group: "Nature & friends", tint: "#ffffff", svg: '<ellipse cx="14" cy="10" rx="3.5" ry="9" fill="{c}" stroke="#c9d6de"/><ellipse cx="26" cy="10" rx="3.5" ry="9" fill="{c}" stroke="#c9d6de"/><ellipse cx="14" cy="10" rx="1.5" ry="6" fill="#f7b5cf"/><ellipse cx="26" cy="10" rx="1.5" ry="6" fill="#f7b5cf"/><circle cx="20" cy="24" r="12" fill="{c}" stroke="#c9d6de"/><circle cx="16" cy="22" r="1.4" fill="#123447"/><circle cx="24" cy="22" r="1.4" fill="#123447"/><path d="M18.5 26.5h3L20 28.5z" fill="#f07cae"/>' },
    { id: "bird", label: "Bird", group: "Nature & friends", tint: "#3aa6c9", svg: '<ellipse cx="20" cy="22" rx="11" ry="8" fill="{c}"/><circle cx="29" cy="15" r="6" fill="{c}"/><path d="M34 15l5 1.5-5 1.5z" fill="#ff8c42"/><circle cx="30.5" cy="13.5" r="1.1" fill="#123447"/><path d="M12 22c-4-2-6-6-6-10 4 1 7 4 8 8z" fill="#000" opacity=".2"/><path d="M16 30v6M22 30v6" stroke="#ff8c42" stroke-width="2" stroke-linecap="round"/>' },
    { id: "butterfly", label: "Butterfly", group: "Nature & friends", tint: "#9b7ede", svg: '<g fill="{c}"><ellipse cx="12" cy="14" rx="8" ry="9" transform="rotate(-20 12 14)"/><ellipse cx="28" cy="14" rx="8" ry="9" transform="rotate(20 28 14)"/><ellipse cx="13" cy="27" rx="6" ry="6"/><ellipse cx="27" cy="27" rx="6" ry="6"/></g><rect x="18.5" y="8" width="3" height="24" rx="1.5" fill="#123447"/><path d="M18 8l-3-5M22 8l3-5" stroke="#123447" stroke-width="1.5" stroke-linecap="round"/>' },
    { id: "paw", label: "Paw print", group: "Nature & friends", tint: "#123447", svg: '<circle cx="20" cy="25" r="7" fill="{c}"/><circle cx="9" cy="17" r="3.5" fill="{c}"/><circle cx="15" cy="10" r="3.5" fill="{c}"/><circle cx="25" cy="10" r="3.5" fill="{c}"/><circle cx="31" cy="17" r="3.5" fill="{c}"/>' },
    { id: "flower", label: "Flower", group: "Nature & friends", tint: "#f07cae", svg: '<g fill="{c}"><circle cx="20" cy="9" r="6"/><circle cx="30" cy="16" r="6"/><circle cx="27" cy="28" r="6"/><circle cx="13" cy="28" r="6"/><circle cx="10" cy="16" r="6"/></g><circle cx="20" cy="19" r="5" fill="#ffc857"/>' },
    { id: "leaf", label: "Leaf", group: "Nature & friends", tint: "#2f7a4f", svg: '<path d="M34 6C14 6 6 18 6 34c16 0 28-8 28-28z" fill="{c}"/><path d="M8 32C16 22 24 14 32 8" stroke="#fff" stroke-width="1.6" fill="none" opacity=".7"/>' },
    { id: "mushroom", label: "Mushroom", group: "Nature & friends", tint: "#d63c4f", svg: '<path d="M4 20a16 14 0 0 1 32 0z" fill="{c}"/><circle cx="12" cy="14" r="2.5" fill="#fff"/><circle cx="22" cy="10" r="2.5" fill="#fff"/><circle cx="29" cy="16" r="2" fill="#fff"/><path d="M14 20h12v12a6 4 0 0 1-12 0z" fill="#f5e6d0"/>' },
    { id: "sun", label: "Sun", group: "Nature & friends", tint: "#ffc857", svg: '<circle cx="20" cy="20" r="8" fill="{c}"/><g stroke="{c}" stroke-width="3" stroke-linecap="round"><path d="M20 3v5M20 32v5M3 20h5M32 20h5M8 8l3.5 3.5M28.5 28.5L32 32M8 32l3.5-3.5M28.5 11.5L32 8"/></g>' },
    { id: "moon", label: "Moon", group: "Nature & friends", tint: "#ffc857", svg: '<path d="M26 4a16 16 0 1 0 10 28A13 13 0 0 1 26 4z" fill="{c}"/>' },
    { id: "cloud", label: "Cloud", group: "Nature & friends", tint: "#ffffff", svg: '<path d="M11 30a7 7 0 0 1-1-14 9 9 0 0 1 17-3 7 7 0 0 1 4 17z" fill="{c}" stroke="#c9d6de"/>' }
  ];
  var STK = {};
  STICKERS.forEach(function (s) { STK[s.id] = s; });
  var STICKER_GROUPS = ["Holidays", "Nature & friends", "Shapes & sweets"];

  // 3D model settings (see design-3d.js). Sizes are multipliers of the standard kit.
  var D3_DEFAULTS = { width: 1, depth: 1, height: 1, roof: "gable", windows: 2, door: true, chimney: true, windmill: false, snow: true, wreath: false, fairy: false, star: true, baubles: true, night: false, spin: true,
    porch: false, wing: false, dormers: false, flowerboxes: false, bell: false, fence: false, pines: false, lamp: false, snowman: false, path: false };
  // Extra building pieces for the 3D house ("Pieces" tab)
  var D3_PIECES = [
    ["Building", [["porch", "Front porch"], ["wing", "Side wing"], ["dormers", "Dormer windows"], ["flowerboxes", "Window flower boxes"], ["bell", "Bell tower"]]],
    ["Garden", [["fence", "Picket fence"], ["pines", "Pine trees"], ["lamp", "Lamp post"], ["snowman", "Snowman"], ["path", "Stone path"]]]
  ];
  var D3_ROOFS = [["gable", "Classic"], ["steep", "Steep A-frame"], ["tower", "Tower"]];
  // Which detail switches each kit has in 3D
  var D3_DETAILS = {
    house: [["door", "Front door"], ["chimney", "Chimney"], ["windmill", "Windmill"], ["snow", "Snow on the roof"], ["wreath", "Wreath on the door"], ["fairy", "Fairy lights"]],
    tree: [["star", "Star on top"], ["baubles", "Baubles"], ["snow", "Snowy branches"], ["fairy", "Fairy lights"]],
    lantern: [["snow", "Snowy roof"]],
    ornament: [["snow", "Snowy cap"]]
  };

  var state = {
    kit: "house", palette: "winter", colors: PALETTES[0].c.slice(), pattern: "plain",
    occasions: [], extras: ["lights"], sky: "none", ground: "none", falling: "none",
    stickers: [], strokes: [],
    mode: "2d", d3: JSON.parse(JSON.stringify(D3_DEFAULTS)),
    name: "", idea: "", firstName: "", email: ""
  };
  // Toolbox state (not saved)
  var ui = { tab: "stickers", tool: "pen", size: "m", color: "#123447", font: "script", textColor: "#22607f", text: "", sel: -1 };
  var photos = []; // { file, url }

  /* ---------- Helpers ---------- */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
  }
  function shade(hex, amt) { // amt -1..1: darken / lighten
    var n = parseInt(hex.slice(1), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
    var f = function (v) { return Math.round(amt < 0 ? v * (1 + amt) : v + (255 - v) * amt); };
    return "#" + ((1 << 24) + (f(r) << 16) + (f(g) << 8) + f(b)).toString(16).slice(1);
  }
  function isLight(hex) {
    var n = parseInt(hex.slice(1), 16);
    return ((n >> 16) * 299 + ((n >> 8) & 255) * 587 + (n & 255) * 114) / 1000 > 200;
  }
  function kitById(id) { return KITS.filter(function (k) { return k.id === id; })[0] || KITS[0]; }
  function labelOf(list, id) { var m = list.filter(function (o) { return o[0] === id; })[0]; return m ? m[1] : id; }
  function paletteName() {
    var p = PALETTES.filter(function (x) { return x.id === state.palette; })[0];
    return p ? p.name : "Custom colors";
  }
  function swatchColors() {
    var out = state.colors.slice();
    EXTRA_SWATCHES.forEach(function (c) { if (out.indexOf(c) < 0) out.push(c); });
    return out;
  }
  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
  var SPARKLE = '<svg class="sparkle" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 0c1 7 5 11 12 12-7 1-11 5-12 12-1-7-5-11-12-12C7 11 11 7 12 0z"/></svg>';
  function sparklePath(x, y, s, fill) {
    return '<path transform="translate(' + (x - 12 * s) + " " + (y - 12 * s) + ") scale(" + s + ')" d="M12 0c1 7 5 11 12 12-7 1-11 5-12 12-1-7-5-11-12-12C7 11 11 7 12 0z" fill="' + fill + '"/>';
  }
  function heartPath(x, y, s, fill) {
    return '<path transform="translate(' + (x - 20 * s) + " " + (y - 20 * s) + ") scale(" + s + ')" d="M20 35S4 24 4 13a8 8 0 0 1 16-3 8 8 0 0 1 16 3c0 11-16 22-16 22z" fill="' + fill + '"/>';
  }
  // Fixed pseudo-random spots for falling snow / sparkles / hearts
  var FALL_POS = (function () {
    var a = [], x = 7;
    for (var i = 0; i < 26; i++) {
      x = (x * 48271) % 2147483647; var px = x % 400;
      x = (x * 48271) % 2147483647; var py = x % 400;
      x = (x * 48271) % 2147483647; a.push([px, py, x % 3]);
    }
    return a;
  })();

  /* ---------- Scene (behind the kit) ---------- */
  function sceneSvg(st, uid) {
    var s = "", g;
    if (st.sky === "day") {
      s += '<defs><linearGradient id="' + uid + '-sky" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#bfe3f5"/><stop offset="1" stop-color="#eef8fd"/></linearGradient></defs>' +
        '<rect width="400" height="400" fill="url(#' + uid + '-sky)"/>' +
        '<circle cx="318" cy="78" r="30" fill="#ffd56b"/>' +
        '<path d="M70 120a16 16 0 0 1 2-32 22 22 0 0 1 42-6 16 16 0 0 1 8 38z" fill="#fff" opacity=".95"/>' +
        '<path d="M250 150a12 12 0 0 1 2-24 17 17 0 0 1 32-4 12 12 0 0 1 6 28z" fill="#fff" opacity=".9"/>';
    } else if (st.sky === "night") {
      s += '<defs><linearGradient id="' + uid + '-sky" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#15304a"/><stop offset="1" stop-color="#2d5a7a"/></linearGradient></defs>' +
        '<rect width="400" height="400" fill="url(#' + uid + '-sky)"/>' +
        '<path d="M318 44a34 34 0 1 0 22 60 28 28 0 0 1-22-60z" fill="#ffe08a"/>';
      FALL_POS.forEach(function (p, i) { if (i % 2 === 0 && p[1] < 230) s += '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="' + (1.5 + p[2]) + '" fill="#fff" opacity=".9"/>'; });
      s += sparklePath(90, 70, 1.1, "#ffe08a") + sparklePath(200, 40, .8, "#ffe08a");
    } else if (st.sky === "sunset") {
      s += '<defs><linearGradient id="' + uid + '-sky" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#9b7ede"/><stop offset=".5" stop-color="#f07cae"/><stop offset="1" stop-color="#ffc06b"/></linearGradient></defs>' +
        '<rect width="400" height="400" fill="url(#' + uid + '-sky)"/>' +
        '<circle cx="200" cy="300" r="46" fill="#ffe08a" opacity=".95"/>';
    }
    if (st.ground === "snow") {
      g = '<path d="M-10 322c60-22 140-22 210-6s140 14 210-4V410H-10z" fill="#f3f8fb"/><path d="M-10 322c60-22 140-22 210-6s140 14 210-4" fill="none" stroke="#d4e4ec" stroke-width="3"/>';
    } else if (st.ground === "grass") {
      g = '<path d="M-10 326c80-14 160-14 240-2s120 10 180-6V410H-10z" fill="#8fcf9f"/><path d="M40 330l4-14 4 14M120 326l3-12 3 12M210 328l4-14 4 14M300 324l3-12 3 12M350 330l4-14 4 14" fill="none" stroke="#5aa870" stroke-width="2.5" stroke-linecap="round"/>';
    } else if (st.ground === "sand") {
      g = '<path d="M-10 328c90-12 180-12 270 0s110 6 150-2V410H-10z" fill="#f3dfae"/><circle cx="60" cy="350" r="2.5" fill="#e3c889"/><circle cx="150" cy="370" r="2" fill="#e3c889"/><circle cx="260" cy="356" r="2.5" fill="#e3c889"/><circle cx="340" cy="372" r="2" fill="#e3c889"/>';
    } else if (st.ground === "water") {
      g = '<path d="M-10 330h420V410H-10z" fill="#8ccfe8"/><path d="M10 350q20-8 40 0t40 0 40 0 40 0 40 0 40 0 40 0 40 0 40 0M30 378q20-8 40 0t40 0 40 0 40 0 40 0 40 0 40 0 40 0" fill="none" stroke="#fff" stroke-width="2.5" opacity=".7"/>';
    }
    if (g) s += g;
    if (st.falling !== "none") {
      FALL_POS.forEach(function (p) {
        if (st.falling === "snow") s += '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="' + (3 + p[2]) + '" fill="#fff" stroke="#d4e4ec" stroke-width="1"/>';
        else if (st.falling === "sparkles") s += sparklePath(p[0], p[1], .5 + p[2] * .3, "#ffc857");
        else s += heartPath(p[0], p[1], .3 + p[2] * .12, "#f07cae");
      });
    }
    return s;
  }

  /* ---------- Stickers ---------- */
  function stickerInner(st) {
    if (st.type === "text") {
      var f = FONTS[st.font] || FONTS.script, w = Math.max(24, st.value.length * 8);
      return '<rect x="' + (20 - w / 2) + '" y="10" width="' + w + '" height="20" fill="#fff" fill-opacity="0"/>' +
        '<text x="20" y="20" text-anchor="middle" dominant-baseline="central" font-size="14" font-weight="' + f[2] + '" font-family="' + f[1].replace(/"/g, "'") + '" fill="' + st.color + '">' + esc(st.value) + "</text>";
    }
    var def = STK[st.type];
    return '<rect width="40" height="40" fill="#fff" fill-opacity="0"/>' + def.svg.split("{c}").join(st.color || def.tint);
  }
  function stickerTransform(st) {
    return "translate(" + st.x.toFixed(1) + " " + st.y.toFixed(1) + ") rotate(" + st.r + ") scale(" + (st.flip ? -st.s : st.s).toFixed(3) + " " + st.s.toFixed(3) + ")";
  }
  function stickerRadius(st) { return (st.type === "text" ? Math.max(22, st.value.length * 4.5) : 24) * st.s + 6; }
  function stickersSvg(st, opts) {
    return st.stickers.map(function (s, i) {
      if (opts.noText && s.type === "text") return "";
      return '<g class="ds-sticker" data-sticker="' + i + '" transform="' + stickerTransform(s) + '"><g transform="translate(-20 -20)">' + stickerInner(s) + "</g></g>";
    }).join("") + (opts.sel > -1 && st.stickers[opts.sel]
      ? '<circle data-ring="1" cx="' + st.stickers[opts.sel].x + '" cy="' + st.stickers[opts.sel].y + '" r="' + stickerRadius(st.stickers[opts.sel]) + '" fill="none" stroke="#f07cae" stroke-width="2" stroke-dasharray="5 5" pointer-events="none"/>'
      : "");
  }
  function stickerPreview(def) {
    return '<svg viewBox="0 0 40 40" aria-hidden="true">' + def.svg.split("{c}").join(def.tint) + "</svg>";
  }

  /* ---------- Freehand strokes ---------- */
  function pathD(pts) {
    if (pts.length === 1) pts = [pts[0], pts[0]];
    return "M" + pts.map(function (p) { return p[0].toFixed(1) + " " + p[1].toFixed(1); }).join("L");
  }
  function strokeSvg(k) {
    return '<path d="' + pathD(k.pts) + '" fill="none" stroke="' + k.color + '" stroke-width="' + k.w + '" stroke-linecap="round" stroke-linejoin="round"/>';
  }

  /* ---------- Kit drawings (400×400 SVG, colors inline so the PNG export matches) ---------- */
  function drawKit(kit, st, uid, opts) {
    opts = opts || {};
    var main = st.colors[0], accent = st.colors[1], trim = st.colors[2];
    var lit = st.extras.indexOf("lights") > -1, moving = st.extras.indexOf("moving") > -1;
    var dark = shade(main, -0.3), accentDark = shade(accent, -0.3);
    var trimLine = isLight(trim) && isLight(main) ? shade(trim, -0.25) : trim;
    var win = lit ? "#ffc857" : shade(main, 0.55);
    var dots = "url(#" + uid + "-dots)", glow = lit ? ' filter="url(#' + uid + '-glow)"' : "";
    var pat = st.pattern !== "plain" ? "url(#" + uid + "-pat)" : "";
    var gem = function (shape) { // diamond-dot texture + optional surface pattern overlay
      return shape.replace("/>", ' fill="' + dots + '"/>') + (pat ? shape.replace("/>", ' fill="' + pat + '"/>') : "");
    };
    var s = "";

    if (kit === "house") {
      s += '<rect x="246" y="92" width="30" height="66" fill="' + accentDark + '"/>' +
        '<rect x="240" y="86" width="42" height="12" rx="4" fill="' + trimLine + '"/>' +
        '<rect x="100" y="172" width="200" height="168" fill="' + main + '"/>' + gem('<rect x="100" y="172" width="200" height="168"/>') +
        '<polygon points="78,182 200,82 322,182" fill="' + accent + '"/>' + gem('<polygon points="78,182 200,82 322,182"/>') +
        '<path d="M78 182 200 82 322 182" fill="none" stroke="' + trimLine + '" stroke-width="12" stroke-linejoin="round" stroke-linecap="round"/>' +
        '<circle cx="200" cy="142" r="15" fill="' + win + '"' + glow + "/>" +
        '<rect x="120" y="200" width="44" height="44" rx="6" fill="' + win + '"' + glow + "/>" +
        '<rect x="236" y="200" width="44" height="44" rx="6" fill="' + win + '"' + glow + "/>" +
        '<path d="M142 200v44M120 222h44M258 200v44M236 222h44" stroke="' + dark + '" stroke-width="4"/>' +
        '<path d="M174 340v-52a26 26 0 0 1 52 0v52z" fill="' + accentDark + '"/>' +
        '<circle cx="215" cy="306" r="4" fill="' + trimLine + '"/>' +
        '<rect x="90" y="334" width="220" height="14" rx="7" fill="' + trimLine + '"/>';
    } else if (kit === "tree") {
      var t1 = shade(main, -0.12), t2 = main, t3 = shade(main, 0.12);
      s += '<rect x="184" y="296" width="32" height="40" fill="#8a5a3b"/>' +
        '<polygon points="200,182 78,306 322,306" fill="' + t1 + '"/>' + gem('<polygon points="200,182 78,306 322,306"/>') +
        '<polygon points="200,122 100,234 300,234" fill="' + t2 + '"/>' + gem('<polygon points="200,122 100,234 300,234"/>') +
        '<polygon points="200,66 122,170 278,170" fill="' + t3 + '"/>' + gem('<polygon points="200,66 122,170 278,170"/>') +
        '<path d="M126 286q74 26 152-12M130 218q70 22 140-14M150 156q50 16 100-10" fill="none" stroke="' + trimLine + '" stroke-width="6" stroke-linecap="round"/>';
      [[160, 196], [244, 186], [118, 270], [206, 252], [282, 284], [178, 132], [230, 144], [150, 300]].forEach(function (p, i) {
        s += '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="' + (i % 2 ? 9 : 11) + '" fill="' + (lit && i % 2 ? "#ffc857" : accent) + '"' + (lit && i % 2 ? glow : "") + "/>";
      });
      s += sparklePath(200, 60, 1.7, "#ffc857") + '<rect x="146" y="334" width="108" height="14" rx="7" fill="' + accentDark + '"/>';
    } else if (kit === "ornament") {
      s += '<circle cx="200" cy="62" r="16" fill="none" stroke="#c9a227" stroke-width="5"/>' +
        '<rect x="176" y="76" width="48" height="30" rx="6" fill="#e0b440"/>' +
        '<circle cx="200" cy="222" r="122" fill="' + main + '"/>' +
        '<clipPath id="' + uid + '-ball"><circle cx="200" cy="222" r="122"/></clipPath>' +
        '<g clip-path="url(#' + uid + '-ball)"><rect x="70" y="196" width="260" height="54" fill="' + accent + '"/>' +
        '<path d="M70 196l20 14 20-14 20 14 20-14 20 14 20-14 20 14 20-14 20 14 20-14 20 14 20-14 20 14M70 250l20-14 20 14 20-14 20 14 20-14 20 14 20-14 20 14 20-14 20 14 20-14 20 14 20-14" fill="none" stroke="' + trimLine + '" stroke-width="5"/></g>' +
        gem('<circle cx="200" cy="222" r="122"/>') +
        '<rect x="180" y="136" width="40" height="40" rx="20" fill="' + win + '"' + glow + "/>" +
        '<ellipse cx="148" cy="160" rx="18" ry="36" transform="rotate(30 148 160)" fill="#fff" opacity=".35"/>' +
        sparklePath(200, 300, 1, trimLine);
    } else if (kit === "lantern") {
      s += '<path d="M168 102a32 32 0 0 1 64 0" fill="none" stroke="' + accentDark + '" stroke-width="9" stroke-linecap="round"/>' +
        '<polygon points="122,148 200,98 278,148" fill="' + accent + '"/>' + gem('<polygon points="122,148 200,98 278,148"/>') +
        '<rect x="138" y="146" width="124" height="166" rx="8" fill="' + main + '"/>' + gem('<rect x="138" y="146" width="124" height="166" rx="8"/>') +
        '<path d="M160 290v-90a40 40 0 0 1 80 0v90z" fill="' + win + '"' + glow + "/>" +
        '<rect x="190" y="236" width="20" height="44" rx="4" fill="#fff8ea"/>' +
        '<path d="M200 214c8 10 8 16 0 22-8-6-8-12 0-22z" fill="' + (lit ? "#ff9f43" : shade(main, 0.3)) + '"/>' +
        '<path d="M138 146h124M138 312h124" stroke="' + trimLine + '" stroke-width="8" stroke-linecap="round"/>' +
        '<rect x="120" y="312" width="160" height="26" rx="8" fill="' + accent + '"/>';
    } else if (kit === "coaster") {
      var c2 = shade(main, -0.15);
      s += '<circle cx="168" cy="196" r="82" fill="' + c2 + '"/>' + gem('<circle cx="168" cy="196" r="82"/>') +
        '<circle cx="236" cy="210" r="82" fill="' + main + '"/>' + gem('<circle cx="236" cy="210" r="82"/>') +
        '<circle cx="236" cy="210" r="60" fill="none" stroke="' + trimLine + '" stroke-width="6" stroke-dasharray="2 12" stroke-linecap="round"/>' +
        sparklePath(236, 210, 2, lit ? "#ffc857" : trimLine) +
        '<rect x="108" y="262" width="184" height="80" rx="16" fill="' + accent + '"/>' + gem('<rect x="108" y="262" width="184" height="80" rx="16"/>') +
        '<path d="M126 284h148" stroke="' + trimLine + '" stroke-width="6" stroke-linecap="round"/>';
    } else if (kit === "cupcake") {
      var cake = function (x, y, k) {
        return '<path d="M' + (x - 22 * k) + " " + y + "h" + 44 * k + "l" + (-6 * k) + " " + 30 * k + "h" + (-32 * k) + 'z" fill="' + accentDark + '"/>' +
          '<circle cx="' + (x - 12 * k) + '" cy="' + (y - 4 * k) + '" r="' + 14 * k + '" fill="' + main + '"/>' +
          '<circle cx="' + (x + 12 * k) + '" cy="' + (y - 4 * k) + '" r="' + 14 * k + '" fill="' + main + '"/>' +
          '<circle cx="' + x + '" cy="' + (y - 18 * k) + '" r="' + 15 * k + '" fill="' + shade(main, 0.15) + '"/>' +
          '<circle cx="' + x + '" cy="' + (y - 36 * k) + '" r="' + 6 * k + '" fill="' + (lit ? "#ffc857" : accent) + '"' + (lit ? glow : "") + "/>";
      };
      s += '<rect x="194" y="120" width="12" height="212" fill="' + trimLine + '"/>' +
        '<ellipse cx="200" cy="330" rx="132" ry="16" fill="' + accent + '"/>' + cake(130, 300, 1) + cake(200, 300, 1) + cake(270, 300, 1) +
        '<ellipse cx="200" cy="232" rx="100" ry="13" fill="' + accent + '"/>' + cake(156, 204, .9) + cake(244, 204, .9) +
        '<ellipse cx="200" cy="140" rx="68" ry="10" fill="' + accent + '"/>' + cake(200, 116, 1.05) +
        sparklePath(200, 60, 1.1, "#ffc857");
    } else {
      s += '<rect x="112" y="196" width="176" height="144" rx="8" fill="' + main + '"/>' + gem('<rect x="112" y="196" width="176" height="144" rx="8"/>') +
        '<rect x="98" y="162" width="204" height="42" rx="8" fill="' + dark + '"/>' + gem('<rect x="98" y="162" width="204" height="42" rx="8"/>') +
        '<rect x="188" y="162" width="24" height="178" fill="' + accent + '"/>' +
        '<path d="M200 162c-30-46-76-30-58-8 10 12 36 10 58 8zM200 162c30-46 76-30 58-8-10 12-36 10-58 8z" fill="' + accent + '" stroke="' + accentDark + '" stroke-width="3"/>' +
        sparklePath(120, 110, 1.4, "#ffc857") + sparklePath(300, 120, 1, "#ffc857") + sparklePath(318, 230, .8, trimLine) +
        '<text x="200" y="292" text-anchor="middle" font-family="Fredoka, Nunito, sans-serif" font-weight="600" font-size="64" fill="' + trimLine + '">?</text>';
    }

    if (lit) s = sparklePath(64, 96, .8, "#ffc857") + sparklePath(338, 70, 1, "#ffc857") + sparklePath(350, 300, .7, "#ffc857") + s;
    if (moving) {
      s += '<g transform="translate(336 334)"><circle r="30" fill="#ffffff" stroke="#b4c8d2" stroke-width="3"/>' +
        '<g class="ds-spin"><path d="M-15 -4a16 16 0 0 1 28-8M15 4a16 16 0 0 1-28 8" fill="none" stroke="#22607f" stroke-width="4" stroke-linecap="round"/>' +
        '<path d="M15 -18l-2 9-9-3zM-15 18l2-9 9 3z" fill="#22607f"/></g></g>';
    }

    var patDef = "";
    if (pat) {
      var pc = trimLine;
      if (st.pattern === "stripes") patDef = '<pattern id="' + uid + '-pat" width="14" height="14" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="7" height="14" fill="' + pc + '" opacity=".35"/></pattern>';
      else if (st.pattern === "polka") patDef = '<pattern id="' + uid + '-pat" width="18" height="18" patternUnits="userSpaceOnUse"><circle cx="9" cy="9" r="4" fill="' + pc + '" opacity=".5"/></pattern>';
      else if (st.pattern === "checks") patDef = '<pattern id="' + uid + '-pat" width="20" height="20" patternUnits="userSpaceOnUse"><rect width="10" height="10" fill="' + pc + '" opacity=".3"/><rect x="10" y="10" width="10" height="10" fill="' + pc + '" opacity=".3"/></pattern>';
      else if (st.pattern === "bricks") patDef = '<pattern id="' + uid + '-pat" width="28" height="28" patternUnits="userSpaceOnUse"><path d="M0 .8h28M0 14.8h28M14 0v14M0 14v14M28 14v14" fill="none" stroke="' + pc + '" stroke-width="1.8" opacity=".55"/></pattern>';
      else if (st.pattern === "hearts") patDef = '<pattern id="' + uid + '-pat" width="22" height="22" patternUnits="userSpaceOnUse">' + heartPath(11, 11, .35, pc).replace("/>", ' opacity=".5"/>') + "</pattern>";
    }

    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" aria-hidden="true">' +
      "<defs>" +
        '<pattern id="' + uid + '-dots" width="9" height="9" patternUnits="userSpaceOnUse"><circle cx="4.5" cy="4.5" r="1.6" fill="#ffffff" opacity=".38"/></pattern>' +
        '<filter id="' + uid + '-glow" x="-60%" y="-60%" width="220%" height="220%"><feGaussianBlur stdDeviation="6" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>' +
        patDef +
      "</defs>" +
      (opts.bare ? "" : sceneSvg(st, uid)) +
      '<ellipse cx="200" cy="352" rx="150" ry="12" fill="#123447" opacity=".1"/>' + s +
      (opts.bare ? "" : stickersSvg(st, opts) + "<g data-strokes=\"1\">" + st.strokes.map(strokeSvg).join("") + "</g>") +
      "</svg>";
  }

  /* ---------- Markup ---------- */
  function radioTile(name, value, inner, checked, cls) {
    return '<label class="' + cls + (checked ? " is-on" : "") + '"><input type="radio" name="' + name + '" value="' + value + '"' + (checked ? " checked" : "") + ">" + inner + "</label>";
  }
  function step(n, title, body, hint) {
    return '<fieldset class="ds-step"><legend><span class="ds-num">' + n + "</span>" + title + "</legend>" +
      (hint ? '<p class="ds-hint">' + hint + "</p>" : "") + body + "</fieldset>";
  }

  function render() {
    var kits = KITS.map(function (k) {
      return radioTile("kit", k.id, '<span class="ds-tile-art" data-kit-art="' + k.id + '"></span><strong>' + k.label + "</strong><small>" + k.hint + "</small>", k.id === state.kit, "ds-tile");
    }).join("");
    var pals = PALETTES.map(function (p) {
      return radioTile("palette", p.id, '<span class="ds-sw">' + p.c.map(function (c) { return '<i style="background:' + c + '"></i>'; }).join("") + "</span>" + p.name, p.id === state.palette, "ds-pal");
    }).join("");
    var colorInput = function (i, label) {
      return '<label class="ds-color"><input type="color" data-color="' + i + '" value="' + state.colors[i] + '">' + label + "</label>";
    };
    var pats = PATTERNS.map(function (p) { return radioTile("pattern", p[0], p[1], p[0] === state.pattern, "ds-chip"); }).join("");
    var occ = OCCASIONS.map(function (o) {
      return '<label class="ds-chip' + (state.occasions.indexOf(o) > -1 ? " is-on" : "") + '"><input type="checkbox" name="occasion" value="' + esc(o) + '"' + (state.occasions.indexOf(o) > -1 ? " checked" : "") + ">" + esc(o) + "</label>";
    }).join("");
    var extras = EXTRAS.map(function (x) {
      var on = state.extras.indexOf(x.id) > -1;
      return '<label class="ds-switch' + (on ? " is-on" : "") + '"><input type="checkbox" name="extra" value="' + x.id + '"' + (on ? " checked" : "") + '><span class="ds-track" aria-hidden="true"></span><span><strong>' + x.label + "</strong><small>" + x.hint + "</small></span></label>";
    }).join("");
    var can3d = window.WebGLRenderingContext && (function () { try { var c = document.createElement("canvas"); return !!(c.getContext("webgl2") || c.getContext("webgl")); } catch (e) { return false; } })();
    if (!can3d) state.mode = "2d";
    var modes = '<div class="ds-modes" role="group" aria-label="Design view">' +
      '<button type="button" data-mode-btn="2d" aria-pressed="' + (state.mode === "2d") + '">2D sketch</button>' +
      '<button type="button" data-mode-btn="3d" aria-pressed="' + (state.mode === "3d") + '"' + (can3d ? "" : ' disabled title="3D needs a newer browser"') + '>3D model <span class="ds-new">New</span></button></div>';

    var modeNote = !cfg.formId
      ? '<p class="ds-mode-note">' + (cfg.mode === "preview"
          ? "<strong>Preview mode:</strong> try everything, but nothing is sent yet. Designs are sent for real once your Forminit form ID is added to the Shopify theme."
          : "Design submissions are opening soon. Please check back shortly.") + "</p>"
      : "";

    root.innerHTML =
      '<div class="ds-grid">' +
        '<div class="ds-preview-col">' + modes +
          '<div class="ds-preview">' +
            '<div class="ds-hoop" data-hoop><div class="ds-art" role="img" tabindex="0" data-art data-tool="move"></div></div>' +
            '<div class="ds-3d" data-3d hidden role="img" aria-label="3D model of your design. Drag to turn it around.">' +
              '<p class="ds-3d-status" data-3d-status>Building your 3D model…</p>' +
              '<div class="ds-3d-zoom"><button type="button" data-act="d3-zoom" data-val="in" aria-label="Zoom in">+</button><button type="button" data-act="d3-zoom" data-val="out" aria-label="Zoom out">−</button></div>' +
              '<p class="ds-3d-hint">Drag to turn it around</p>' +
            "</div>" +
            '<div class="ds-label"><i class="note-tape"></i>' +
              '<p class="ds-label-name" data-label-name></p>' +
              '<p class="ds-label-meta" data-label-meta></p>' +
              '<div class="ds-label-sw" data-label-sw></div>' +
            "</div>" +
          "</div>" +
          '<div class="ds-cloud" data-cloud-bar></div>' +
          '<div class="ds-tools" data-tools>' +
            '<div class="ds-tabs" role="tablist" aria-label="Decorate your design" data-tabs></div>' +
            '<div class="ds-panel" data-panel></div>' +
          "</div>" +
          '<p class="ds-preview-note">' + SPARKLE + '<span data-preview-note>This is a quick sketch of your idea. Our artists hand-draw every final design.</span></p>' +
        "</div>" +
        '<form class="ds-form" novalidate>' +
          step(1, "Pick a kit shape", '<div class="ds-kits">' + kits + "</div>") +
          step(2, "Choose your colors", '<div class="ds-pals">' + pals + "</div>" +
            '<div class="ds-colors"><span class="ds-colors-label">Fine-tune:</span>' + colorInput(0, "Main") + colorInput(1, "Accent") + colorInput(2, "Trim") + "</div>" +
            '<p class="ds-sub" style="margin-top:18px">Surface pattern</p><div class="ds-chips">' + pats + "</div>") +
          step(3, "Make it special", '<p class="ds-sub">Occasion <small>(pick any)</small></p><div class="ds-chips">' + occ + "</div>" +
            '<p class="ds-sub">Extras</p><div class="ds-extras">' + extras + "</div>" +
            '<p class="ds-hint" style="margin-top:14px">Want more? Use the <strong>Stickers, Draw, Words and Scene</strong> tools under the preview to decorate your design however you like.</p>') +
          step(4, "Tell us your idea",
            '<div class="ds-field"><label for="ds-name">Design name <small>(optional)</small></label><input id="ds-name" name="name" type="text" maxlength="40" placeholder="e.g. Snowy Owl Cabin" value="' + esc(state.name) + '"></div>' +
            '<div class="ds-field" data-field="idea"><label for="ds-idea">Describe your design</label>' +
              '<textarea id="ds-idea" name="idea" rows="5" maxlength="2000" placeholder="What does it look like? Who is it for? Any little details you love, like a wreath on the door, a sleeping cat or snow on the roof?">' + esc(state.idea) + "</textarea>" +
              '<p class="ds-counter"><span data-count>0</span> / 2000</p><p class="ds-error" data-error="idea" hidden></p></div>' +
            '<div class="ds-field"><p class="ds-sub" id="ds-photos-label">Sketches or photos <small>(optional, up to ' + MAX_PHOTOS + ")</small></p>" +
              '<label class="ds-drop" data-drop><input type="file" accept="image/*" multiple data-photos aria-labelledby="ds-photos-label">' +
                "<strong>Add a drawing, a doodle or an inspiration photo</strong><small>Tap to choose, or drag pictures here</small></label>" +
              '<div class="ds-thumbs" data-thumbs></div><p class="ds-error" data-error="photos" hidden></p></div>') +
          step(5, "About you",
            '<div class="ds-two">' +
              '<div class="ds-field" data-field="firstName"><label for="ds-first">First name</label><input id="ds-first" name="firstName" type="text" autocomplete="given-name" maxlength="60" value="' + esc(state.firstName) + '"><p class="ds-error" data-error="firstName" hidden></p></div>' +
              '<div class="ds-field" data-field="email"><label for="ds-email">Email</label><input id="ds-email" name="email" type="email" autocomplete="email" maxlength="120" value="' + esc(state.email) + '"><p class="ds-error" data-error="email" hidden></p></div>' +
            "</div>" +
            '<div class="ds-field" data-field="consent"><label class="ds-check"><input type="checkbox" name="consent"><span>' + esc(cfg.consent) + "</span></label><p class=\"ds-error\" data-error=\"consent\" hidden></p></div>" +
            '<div class="ds-hp" aria-hidden="true"><label>Leave this empty <input type="text" name="website" tabindex="-1" autocomplete="off"></label></div>' +
            '<button class="btn btn-primary ds-submit" type="submit">' + SPARKLE + "Send my design</button>" +
            '<div class="ds-status" role="status" aria-live="polite" data-status></div>' + modeNote) +
        "</form>" +
      "</div>";

    bind();
    renderCloudBar();
    applyMode();
    updateArt();
    updateLabel();
    renderPanel();
  }

  function designData() {
    var data = {};
    Object.keys(state).forEach(function (k) { if (["firstName", "email", "idea", "name"].indexOf(k) < 0) data[k] = state[k]; });
    return data;
  }

  /* ---------- Save designs to the customer's account (see gc-cloud.js) ---------- */
  var MAX_SAVED = 20, savedDesigns = null, savedOpen = false, currentSavedId = null, cloudMsg = "";
  function cloudStatus() { return window.GCCloud ? GCCloud.status() : null; }
  function cloudReady() { var c = cloudStatus(); return !!(c && c.loggedIn && c.cloud === "ok"); }
  function loadSaved() {
    if (savedDesigns) return Promise.resolve(savedDesigns);
    return GCCloud.load("designs").then(function (v) { savedDesigns = Array.isArray(v) ? v.filter(function (d) { return d && d.id && d.data; }) : []; return savedDesigns; });
  }
  function renderCloudBar() {
    var bar = root.querySelector("[data-cloud-bar]"), c = cloudStatus();
    if (!bar) { // thank-you screen: the button itself shows how saving went
      var btn = root.querySelector('.ds-done [data-cloud="save"]');
      if (btn && cloudMsg) { btn.textContent = cloudMsg; btn.disabled = /^Saved/.test(cloudMsg); }
      return;
    }
    if (!c || c.mode === "off") { bar.hidden = true; return; }
    bar.hidden = false;
    var icon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 18a4.5 4.5 0 0 1-.6-9A6 6 0 0 1 18 9.5a4.3 4.3 0 0 1-.5 8.5z"/></svg>';
    var list = "";
    if (savedOpen && savedDesigns) {
      list = savedDesigns.length ? '<ul class="ds-saved">' + savedDesigns.map(function (d) {
        return '<li><button type="button" class="ds-saved-open" data-cloud="open" data-id="' + esc(d.id) + '"><strong>' + esc(d.name) + "</strong><small>" + esc(d.kit || "") + (d.mode === "3d" ? " · 3D" : "") + " · " + new Date(d.saved).toLocaleDateString("en-US", { month: "short", day: "numeric" }) + "</small></button>" +
          '<button type="button" class="ds-saved-del" data-cloud="delete" data-id="' + esc(d.id) + '" aria-label="Delete ' + esc(d.name) + '">&times;</button></li>';
      }).join("") + "</ul>" : '<p class="ds-tip">No saved designs yet. Press <strong>Save this design</strong> to keep one.</p>';
    }
    bar.innerHTML = '<div class="ds-cloud-row">' + icon +
      '<button type="button" class="ds-tb-btn" data-cloud="save">' + (currentSavedId ? "Save changes" : "Save this design") + "</button>" +
      '<button type="button" class="ds-tb-btn" data-cloud="list" aria-expanded="' + savedOpen + '">My saved designs' + (savedDesigns && savedDesigns.length ? " (" + savedDesigns.length + ")" : "") + "</button></div>" +
      (cloudMsg ? '<p class="ds-cloud-msg" role="status">' + esc(cloudMsg) + "</p>" : "") + list;
  }
  function cloudAction(act, id) {
    if (!cloudReady()) {
      GCCloud.invite(act === "save" ? "Create a free GleamCanvas account to save this design to our cloud, so you can come back to it on any phone or computer." :
        "Create a free GleamCanvas account to keep your designs in our cloud and open them on any device.");
      return;
    }
    if (act === "list") {
      savedOpen = !savedOpen; cloudMsg = savedOpen ? "Loading your designs…" : "";
      renderCloudBar();
      if (savedOpen) loadSaved().then(function () { cloudMsg = ""; renderCloudBar(); }, function () { cloudMsg = "Couldn't load your designs. Please try again."; renderCloudBar(); });
      return;
    }
    if (act === "save") {
      cloudMsg = "Saving…"; renderCloudBar();
      loadSaved().then(function (list) {
        var kit = kitById(state.kit), entry = { id: currentSavedId || ("d" + Date.now()), name: (state.name.trim() || "My " + kit.label.toLowerCase()).slice(0, 40), kit: kit.label, mode: state.mode, saved: Date.now(), data: designData() };
        var rest = list.filter(function (d) { return d.id !== entry.id; });
        if (rest.length >= MAX_SAVED) throw new Error("full");
        var next = [entry].concat(rest);
        return GCCloud.save("designs", next).then(function () { savedDesigns = next; currentSavedId = entry.id; cloudMsg = 'Saved "' + entry.name + '" to your account.'; });
      }).catch(function (e) {
        cloudMsg = e && e.message === "full" ? "You have " + MAX_SAVED + " saved designs. Delete one to make room." :
          e && e.message === "too-big" ? "This design is too big to save. Try removing some drawing or stickers." : "Couldn't save right now. Please try again.";
      }).then(renderCloudBar);
      return;
    }
    var d = (savedDesigns || []).filter(function (x) { return x.id === id; })[0];
    if (!d) return;
    if (act === "open") {
      Object.keys(FRESH).forEach(function (k) { if (["firstName", "email", "idea", "name"].indexOf(k) < 0) state[k] = JSON.parse(JSON.stringify(FRESH[k])); });
      restore(d.data);
      state.name = d.name;
      currentSavedId = d.id; savedOpen = false; cloudMsg = 'Opened "' + d.name + '".';
      ui.sel = -1; ui.tab = state.mode === "3d" ? "shape" : "stickers";
      render();
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    } else if (act === "delete") {
      if (!window.confirm('Delete "' + d.name + '" from your account?')) return;
      var next = savedDesigns.filter(function (x) { return x !== d; });
      GCCloud.save("designs", next).then(function () { savedDesigns = next; if (currentSavedId === d.id) currentSavedId = null; cloudMsg = "Deleted."; }, function () { cloudMsg = "Couldn't delete right now. Please try again."; }).then(renderCloudBar);
    }
  }
  root.addEventListener("click", function (e) {
    var b = e.target.closest("[data-cloud]");
    if (b) cloudAction(b.getAttribute("data-cloud"), b.getAttribute("data-id"));
  });
  if (window.GCCloud) {
    GCCloud.ready.then(renderCloudBar);
    GCCloud.onChange(function () { savedDesigns = null; savedOpen = false; cloudMsg = ""; currentSavedId = null; renderCloudBar(); });
  }

  /* ---------- 2D sketch / 3D model ---------- */
  var viewer = null, viewerLoading = null;
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = src; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  function ensureViewer() {
    if (viewer) return Promise.resolve(viewer);
    if (!viewerLoading) {
      viewerLoading = (window.GC3D ? Promise.resolve() : loadScript(cfg.d3Src))
        .then(function () { return window.GC3D.mount(root.querySelector("[data-3d]"), { threeSrc: cfg.threeSrc }); })
        .then(function (v) { viewer = v; var st = root.querySelector("[data-3d-status]"); if (st) st.hidden = true; return v; })
        .catch(function (e) {
          viewerLoading = null;
          var st = root.querySelector("[data-3d-status]");
          if (st) st.textContent = "Sorry, the 3D view couldn't load. Please check your connection, or use the 2D sketch.";
          throw e;
        });
    }
    return viewerLoading;
  }
  function applyMode() {
    var is3d = state.mode === "3d";
    root.querySelector("[data-hoop]").hidden = is3d;
    var box3d = root.querySelector("[data-3d]");
    box3d.hidden = !is3d;
    root.querySelectorAll("[data-mode-btn]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-mode-btn") === state.mode)); });
    root.querySelector("[data-preview-note]").textContent = is3d
      ? "This is a quick 3D sketch of your idea. Our artists and engineers design every final kit by hand."
      : "This is a quick sketch of your idea. Our artists hand-draw every final design.";
    if (is3d) {
      // A fresh panel of 3D tools; re-attach the viewer if the studio was redrawn
      if (viewer && viewer.el !== box3d) { viewer.attach(box3d); root.querySelector("[data-3d-status]").hidden = true; }
      ensureViewer().then(function () { updateArt(); }, function () {});
    }
  }
  function setMode(m) {
    if (m === state.mode) return;
    state.mode = m;
    ui.sel = -1;
    ui.tab = m === "3d" ? "shape" : "stickers";
    applyMode();
    updateArt();
    renderPanel();
  }

  /* ---------- Toolbox panel ---------- */
  function tb(act, label, disabled) {
    return '<button type="button" class="ds-tb-btn" data-act="' + act + '"' + (disabled ? " disabled" : "") + ">" + label + "</button>";
  }
  function swatches(current, act) {
    return '<div class="ds-swatches">' + swatchColors().map(function (c) {
      return '<button type="button" class="ds-swatch" data-act="' + act + '" data-val="' + c + '" aria-label="' + c + '" aria-pressed="' + (c.toLowerCase() === String(current).toLowerCase()) + '" style="background:' + c + '"></button>';
    }).join("") + "</div>";
  }
  function chips(list, current, act) {
    return '<div class="ds-opts">' + list.map(function (o) {
      return '<button type="button" class="ds-opt" data-act="' + act + '" data-val="' + o[0] + '" aria-pressed="' + (o[0] === current) + '">' + o[1] + "</button>";
    }).join("") + "</div>";
  }
  var fontList = Object.keys(FONTS).map(function (k) { return [k, FONTS[k][0]]; });
  var sizeList = SIZES.map(function (z) { return [z[0], z[1]]; });

  function selectionHtml(sel) {
    var isText = sel.type === "text";
    var h = '<div class="ds-selbar"><p class="ds-sub">Selected: ' + (isText ? "your words" : STK[sel.type].label) + "</p>" +
      '<div class="ds-tb">' + tb("bigger", "Bigger") + tb("smaller", "Smaller") + tb("rotate", "Rotate") + (isText ? "" : tb("flip", "Flip")) + tb("front", "To front") + tb("remove", "Remove") + "</div>";
    if (isText) {
      h += '<div class="ds-field"><label for="ds-text">Edit your words</label><input id="ds-text" type="text" maxlength="' + MAX_TEXT + '" data-text-input value="' + esc(sel.value) + '"></div>' +
        chips(fontList, sel.font, "font");
    }
    h += '<p class="ds-sub">Color</p>' + swatches(sel.color, "tint") + '<p class="ds-tip">Drag it around the picture, or nudge it with the arrow keys.</p></div>';
    return h;
  }
  var TABS_2D = [["stickers", "Stickers"], ["draw", "Draw"], ["text", "Words"], ["scene", "Scene"]];
  var TABS_3D = [["shape", "Shape"], ["details", "Details"], ["pieces", "Pieces"], ["view", "View"]];
  function slider(key, label, min, max, step) {
    var v = state.d3[key];
    return '<div class="ds-slider"><label for="ds-d3-' + key + '">' + label + ' <strong data-d3-out="' + key + '">' + Math.round(v * 100) + "%</strong></label>" +
      '<input id="ds-d3-' + key + '" type="range" min="' + min + '" max="' + max + '" step="' + step + '" value="' + v + '" data-d3-range="' + key + '"></div>';
  }
  function d3Switch(key, label) {
    var on = !!state.d3[key];
    return '<button type="button" class="ds-switch' + (on ? " is-on" : "") + '" data-act="d3-toggle" data-val="' + key + '" aria-pressed="' + on + '"><span class="ds-track" aria-hidden="true"></span><span><strong>' + label + "</strong></span></button>";
  }
  function panel3d() {
    var d3 = state.d3, isHouse = state.kit === "house", h = "";
    if (ui.tab === "shape") {
      if (isHouse) {
        h += '<p class="ds-tip">Shape your house. Drag the model to see it from every side.</p>' +
          slider("width", "Width", 0.7, 1.4, 0.05) + slider("depth", "Depth", 0.7, 1.4, 0.05) + slider("height", "Wall height", 0.7, 1.5, 0.05) +
          '<div class="ds-row"><span class="ds-row-label">Roof</span>' + chips(D3_ROOFS, d3.roof, "d3-roof") + "</div>";
      } else {
        h += '<p class="ds-tip">Make your ' + kitById(state.kit).label.toLowerCase() + " bigger or smaller. Colors and the surface pattern come from step 2 of the form.</p>" +
          slider("height", "Size", 0.7, 1.5, 0.05);
      }
    } else if (ui.tab === "pieces") {
      if (isHouse) {
        h += '<p class="ds-tip">Add building pieces and garden touches. The base grows to fit them.</p>';
        D3_PIECES.forEach(function (grp) {
          h += '<p class="ds-sub">' + grp[0] + '</p><div class="ds-d3-switches">' + grp[1].map(function (x) { return d3Switch(x[0], x[1]); }).join("") + "</div>";
        });
        h += '<p class="ds-tip">Tip: the bell swings when <strong>Moving parts</strong> is on, and the lamp post glows in the night view.</p>';
      } else {
        h += '<p class="ds-tip">Building pieces are for the <strong>Holiday house</strong>. Pick it in step 1 to add a porch, a side wing, a garden and more.</p>';
      }
    } else if (ui.tab === "details") {
      var list = D3_DETAILS[state.kit];
      if (isHouse) h += '<div class="ds-row"><span class="ds-row-label">Windows</span>' + chips([["0", "None"], ["1", "1"], ["2", "2"], ["3", "3"]], String(d3.windows), "d3-windows") + '</div><p class="ds-tip">Windows per side, plus two at the front.</p>';
      if (list) h += '<div class="ds-d3-switches">' + list.map(function (x) { return d3Switch(x[0], x[1]); }).join("") + "</div>";
      else h += '<p class="ds-tip">This kit keeps it simple: style it with the colors, surface pattern and extras in the form.</p>';
      h += '<p class="ds-tip">Tip: turn on <strong>Lights up</strong> or <strong>Moving parts</strong> in step 3 to see them glow and spin.</p>';
    } else {
      h += '<div class="ds-d3-switches">' + d3Switch("spin", "Turn slowly on its own") + d3Switch("night", "Night view (see the glow)") + "</div>" +
        '<div class="ds-tb">' + tb("d3-reset", "Reset view") + tb("d3-save", "Save 3D picture") + "</div>" +
        '<p class="ds-tip">Drag to turn the model, pinch or use + and − to zoom, and double-click to reset.</p>';
    }
    return h;
  }
  function renderPanel() {
    var panel = root.querySelector("[data-panel]");
    if (!panel) return;
    var sel = state.stickers[ui.sel], h = "";
    var tabs = state.mode === "3d" ? TABS_3D : TABS_2D;
    if (!tabs.some(function (t) { return t[0] === ui.tab; })) ui.tab = tabs[0][0];
    root.querySelector("[data-tabs]").innerHTML = tabs.map(function (t) {
      return '<button type="button" role="tab" data-tab="' + t[0] + '" aria-selected="' + (ui.tab === t[0]) + '">' + t[1] + "</button>";
    }).join("");
    if (state.mode === "3d") {
      h = panel3d();
    } else if (ui.tab === "stickers") {
      if (sel) h += selectionHtml(sel);
      else h += '<p class="ds-tip">Tap a sticker to add it, then drag it anywhere on the picture. ' + (state.stickers.length ? "Tap a placed sticker to resize, turn or recolor it." : "") + "</p>";
      STICKER_GROUPS.forEach(function (g) {
        h += '<p class="ds-sub">' + g + '</p><div class="ds-stk-grid">' + STICKERS.filter(function (s) { return s.group === g; }).map(function (s) {
          return '<button type="button" class="ds-stk" data-act="add" data-val="' + s.id + '" title="' + s.label + '" aria-label="Add ' + s.label + '">' + stickerPreview(s) + "</button>";
        }).join("") + "</div>";
      });
    } else if (ui.tab === "draw") {
      h += '<p class="ds-tip">Draw right on the picture with your finger or mouse.</p>' +
        '<div class="ds-row"><span class="ds-row-label">Tool</span>' + chips([["pen", "Pen"], ["erase", "Eraser"]], ui.tool, "tool") + "</div>" +
        '<div class="ds-row"><span class="ds-row-label">Line</span>' + chips(sizeList, ui.size, "size") + "</div>" +
        '<p class="ds-sub">Color</p>' + swatches(ui.color, "drawColor") +
        '<div class="ds-tb">' + tb("undo", "Undo last line", !state.strokes.length) + tb("clear", "Clear drawing", !state.strokes.length) + "</div>";
    } else if (ui.tab === "text") {
      h += '<div class="ds-field"><label for="ds-text">Your words <small>(up to ' + MAX_TEXT + " letters)</small></label>" +
        '<input id="ds-text" type="text" maxlength="' + MAX_TEXT + '" data-text-input value="' + esc(ui.text) + '" placeholder="e.g. Noel, Home, Mia"></div>' +
        '<div class="ds-row"><span class="ds-row-label">Style</span>' + chips(fontList, ui.font, "font") + "</div>" +
        '<p class="ds-sub">Color</p>' + swatches(ui.textColor, "textColor") +
        '<div class="ds-tb"><button type="button" class="btn btn-sm btn-primary" data-act="addText">Add to design</button></div>' +
        '<p class="ds-tip">Once added, you can drag, resize and turn your words like a sticker.</p>';
    } else {
      h += '<div class="ds-row"><span class="ds-row-label">Sky</span>' + chips(SKIES, state.sky, "sky") + "</div>" +
        '<div class="ds-row"><span class="ds-row-label">Ground</span>' + chips(GROUNDS, state.ground, "ground") + "</div>" +
        '<div class="ds-row"><span class="ds-row-label">Falling</span>' + chips(FALLING, state.falling, "falling") + "</div>";
    }
    panel.innerHTML = h;
    syncArtMode();
  }
  function syncArtMode() {
    artEl.setAttribute("data-tool", ui.tab === "draw" ? ui.tool : "move");
    artEl.classList.toggle("has-sel", ui.sel > -1);
  }

  /* ---------- Live preview ---------- */
  var form, artEl, saveTimer;
  function updateArt() {
    if (state.mode === "3d" && viewer) viewer.update(state);
    artEl.innerHTML = drawKit(state.kit, state, "ds-main", { sel: ui.sel });
    root.querySelectorAll("[data-kit-art]").forEach(function (el) {
      el.innerHTML = drawKit(el.getAttribute("data-kit-art"), state, "ds-" + el.getAttribute("data-kit-art"), { bare: true });
    });
    var kit = kitById(state.kit), bits = [kit.label + " in " + paletteName()];
    if (state.extras.length) bits.push(state.extras.map(function (id) { return EXTRAS.filter(function (x) { return x.id === id; })[0].label.toLowerCase(); }).join(", "));
    if (state.stickers.length) bits.push(state.stickers.length + " sticker" + (state.stickers.length > 1 ? "s" : ""));
    if (state.strokes.length) bits.push("freehand drawing");
    artEl.setAttribute("aria-label", "Preview: " + bits.join(", ") + ". Use the tools below to decorate it.");
    saveDraft();
  }
  function updateLabel() {
    var kit = kitById(state.kit);
    root.querySelector("[data-label-name]").textContent = state.name.trim() || "My " + kit.label.toLowerCase();
    root.querySelector("[data-label-meta]").textContent = [kit.label].concat(state.occasions.slice(0, 2)).join(" · ");
    root.querySelector("[data-label-sw]").innerHTML = state.colors.map(function (c) { return '<i style="background:' + c + '"></i>'; }).join("") +
      "<span>" + esc(paletteName()) + "</span>";
    root.querySelector("[data-count]").textContent = state.idea.length;
    saveDraft();
  }
  function update() { updateArt(); updateLabel(); }

  function syncOn(name) { // keep the .is-on class in step with checked inputs
    form.querySelectorAll('input[name="' + name + '"]').forEach(function (i) { i.parentNode.classList.toggle("is-on", i.checked); });
  }
  function checkedValues(name) {
    return Array.prototype.map.call(form.querySelectorAll('input[name="' + name + '"]:checked'), function (i) { return i.value; });
  }

  function select(idx) {
    ui.sel = idx;
    if (idx > -1 && ui.tab !== "stickers") ui.tab = "stickers";
    updateArt();
    renderPanel();
  }
  function addSticker(type, extra) {
    if (state.stickers.length >= MAX_STICKERS) return;
    var n = state.stickers.length;
    var st = { type: type, x: 200 + ((n * 37) % 90) - 45, y: 220 + ((n * 53) % 70) - 35, s: type === "text" ? 2.6 : 1.75, r: 0, flip: false, color: type === "text" ? ui.textColor : STK[type].tint };
    if (extra) Object.keys(extra).forEach(function (k) { st[k] = extra[k]; });
    state.stickers.push(st);
    select(state.stickers.length - 1);
    artEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  function bind() {
    form = root.querySelector(".ds-form");
    artEl = root.querySelector("[data-art]");

    form.addEventListener("change", function (e) {
      var t = e.target;
      if (t.name === "kit") { state.kit = t.value; syncOn("kit"); }
      else if (t.name === "palette") {
        state.palette = t.value;
        state.colors = PALETTES.filter(function (p) { return p.id === t.value; })[0].c.slice();
        form.querySelectorAll("[data-color]").forEach(function (c) { c.value = state.colors[+c.getAttribute("data-color")]; });
        syncOn("palette");
      }
      else if (t.name === "pattern") { state.pattern = t.value; syncOn("pattern"); }
      else if (t.name === "occasion") { state.occasions = checkedValues("occasion"); syncOn("occasion"); }
      else if (t.name === "extra") { state.extras = checkedValues("extra"); syncOn("extra"); }
      else if (t.name === "consent") { clearError("consent"); return; }
      else return;
      update();
      if (t.name === "palette") renderPanel(); // swatches follow the palette
    });
    form.addEventListener("input", function (e) {
      var t = e.target;
      if (t.hasAttribute("data-color")) {
        state.colors[+t.getAttribute("data-color")] = t.value;
        state.palette = "custom";
        form.querySelectorAll('input[name="palette"]').forEach(function (r) { r.checked = false; });
        syncOn("palette");
        update();
      } else if (t.name === "name" || t.name === "idea" || t.name === "firstName" || t.name === "email") {
        state[t.name] = t.value;
        clearError(t.name);
        updateLabel();
      }
    });

    var drop = root.querySelector("[data-drop]"), fileInput = root.querySelector("[data-photos]");
    fileInput.addEventListener("change", function () { addPhotos(fileInput.files); fileInput.value = ""; });
    ["dragenter", "dragover"].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add("is-over"); }); });
    ["dragleave", "drop"].forEach(function (ev) { drop.addEventListener(ev, function () { drop.classList.remove("is-over"); }); });
    drop.addEventListener("drop", function (e) { e.preventDefault(); if (e.dataTransfer) addPhotos(e.dataTransfer.files); });
    root.querySelector("[data-thumbs]").addEventListener("click", function (e) {
      var b = e.target.closest("[data-remove]");
      if (!b) return;
      var i = +b.getAttribute("data-remove");
      URL.revokeObjectURL(photos[i].url);
      photos.splice(i, 1);
      renderThumbs();
    });

    form.addEventListener("submit", onSubmit);
    renderThumbs();
    bindTools();
    bindCanvas();
  }

  /* ---------- Toolbox actions ---------- */
  // 3D tools: returns true when it handled the action
  function d3Action(act, val, btn) {
    if (act.indexOf("d3-") !== 0) return false;
    var d3 = state.d3;
    if (act === "d3-zoom") { if (viewer) viewer.zoom(val === "in" ? 0.85 : 1.18); return true; }
    if (act === "d3-reset") { if (viewer) viewer.resetView(); return true; }
    if (act === "d3-save") {
      if (!viewer) return true;
      viewer.snapshot(1200).then(function (b) {
        if (!b) return;
        var a = document.createElement("a");
        a.href = URL.createObjectURL(b); a.download = "my-gleamcanvas-3d-design.png";
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
      });
      return true;
    }
    if (act === "d3-toggle") d3[val] = !d3[val];
    else if (act === "d3-roof") d3.roof = val;
    else if (act === "d3-windows") d3.windows = +val;
    updateArt();
    renderPanel();
    var again = root.querySelector('[data-act="' + act + '"][data-val="' + val + '"]');
    if (again && btn === document.activeElement) again.focus(); // keep keyboard focus after redraw
    return true;
  }

  function bindTools() {
    var tools = root.querySelector("[data-tools]");
    // 2D / 3D switch, and the zoom buttons on the 3D view
    root.querySelector(".ds-modes").addEventListener("click", function (e) {
      var b = e.target.closest("[data-mode-btn]");
      if (b && !b.disabled) setMode(b.getAttribute("data-mode-btn"));
    });
    root.querySelector("[data-3d]").addEventListener("click", function (e) {
      var b = e.target.closest("[data-act]");
      if (b) d3Action(b.getAttribute("data-act"), b.getAttribute("data-val"), b);
    });
    tools.addEventListener("input", function (e) {
      var k = e.target.getAttribute("data-d3-range");
      if (!k) return;
      state.d3[k] = Math.round(parseFloat(e.target.value) * 100) / 100;
      var out = tools.querySelector('[data-d3-out="' + k + '"]');
      if (out) out.textContent = Math.round(state.d3[k] * 100) + "%";
      updateArt();
    });
    tools.addEventListener("click", function (e) {
      var b = e.target.closest("[data-act],[data-tab]");
      if (!b || b.disabled) return;
      if (b.hasAttribute("data-tab")) { ui.tab = b.getAttribute("data-tab"); renderPanel(); return; }
      var act = b.getAttribute("data-act"), val = b.getAttribute("data-val"), sel = state.stickers[ui.sel];
      if (d3Action(act, val, b)) return;
      var input = tools.querySelector("[data-text-input]");
      if (act === "add") { addSticker(val); return; }
      if (act === "addText") {
        var v = (input && input.value || "").trim().slice(0, MAX_TEXT);
        if (!v) { if (input) input.focus(); return; }
        ui.text = "";
        addSticker("text", { value: v, font: ui.font, color: ui.textColor });
        return;
      }
      if (act === "tool") ui.tool = val;
      else if (act === "size") ui.size = val;
      else if (act === "drawColor") ui.color = val;
      else if (act === "undo") state.strokes.pop();
      else if (act === "clear") state.strokes = [];
      else if (act === "sky" || act === "ground" || act === "falling") state[act] = val;
      else if (act === "font") { if (sel && sel.type === "text") sel.font = val; else ui.font = val; }
      else if (act === "textColor") ui.textColor = val;
      else if (!sel) return;
      else if (act === "bigger") sel.s = Math.min(6, sel.s * 1.2);
      else if (act === "smaller") sel.s = Math.max(0.5, sel.s / 1.2);
      else if (act === "rotate") sel.r = (sel.r + 15) % 360;
      else if (act === "flip") sel.flip = !sel.flip;
      else if (act === "front") { state.stickers.push(state.stickers.splice(ui.sel, 1)[0]); ui.sel = state.stickers.length - 1; }
      else if (act === "remove") { state.stickers.splice(ui.sel, 1); ui.sel = -1; }
      else if (act === "tint") sel.color = val;
      updateArt();
      renderPanel();
    });
    tools.addEventListener("input", function (e) {
      if (!e.target.hasAttribute("data-text-input")) return;
      var sel = state.stickers[ui.sel];
      if (sel && sel.type === "text") { sel.value = e.target.value.slice(0, MAX_TEXT); if (!sel.value) sel.value = " "; updateArt(); }
      else ui.text = e.target.value;
    });
    tools.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && e.target.hasAttribute("data-text-input")) {
        e.preventDefault();
        var sel = state.stickers[ui.sel];
        if (sel && sel.type === "text") select(-1);
        else { var btn = tools.querySelector('[data-act="addText"]'); if (btn) btn.click(); }
      }
    });
  }

  /* ---------- Canvas: dragging stickers and drawing ---------- */
  function bindCanvas() {
    var drag = null;
    function pt(e) {
      var r = artEl.getBoundingClientRect();
      return [(e.clientX - r.left) / r.width * 400, (e.clientY - r.top) / r.height * 400];
    }
    function strokeWidth() { return SIZES.filter(function (z) { return z[0] === ui.size; })[0][2]; }
    function eraseAt(p) {
      var r2 = 16 * 16, before = state.strokes.length;
      state.strokes = state.strokes.filter(function (k) {
        return !k.pts.some(function (q) { var dx = q[0] - p[0], dy = q[1] - p[1]; return dx * dx + dy * dy < r2 + k.w * k.w; });
      });
      if (state.strokes.length !== before) { updateArt(); renderPanel(); }
    }

    artEl.addEventListener("pointerdown", function (e) {
      if (e.button != null && e.button !== 0) return;
      var p = pt(e);
      if (ui.tab === "draw") {
        e.preventDefault();
        if (ui.tool === "erase") { eraseAt(p); drag = { type: "erase" }; artEl.setPointerCapture(e.pointerId); return; }
        if (state.strokes.length >= MAX_STROKES) return;
        var layer = artEl.querySelector("[data-strokes]");
        if (!layer) return;
        var el = document.createElementNS(NS, "path");
        el.setAttribute("fill", "none"); el.setAttribute("stroke", ui.color); el.setAttribute("stroke-width", strokeWidth());
        el.setAttribute("stroke-linecap", "round"); el.setAttribute("stroke-linejoin", "round"); el.setAttribute("d", pathD([p]));
        layer.appendChild(el);
        drag = { type: "draw", pts: [p], el: el };
        artEl.setPointerCapture(e.pointerId);
        return;
      }
      var g = e.target.closest ? e.target.closest("[data-sticker]") : null;
      if (g) {
        var idx = +g.getAttribute("data-sticker"), s = state.stickers[idx];
        if (ui.sel !== idx) select(idx);
        g = artEl.querySelector('[data-sticker="' + idx + '"]'); // re-rendered by select()
        e.preventDefault();
        artEl.focus({ preventScroll: true });
        drag = { type: "move", idx: idx, dx: s.x - p[0], dy: s.y - p[1], el: g, ring: artEl.querySelector("[data-ring]") };
        artEl.setPointerCapture(e.pointerId);
      } else if (ui.sel > -1) {
        select(-1);
      }
    });
    artEl.addEventListener("pointermove", function (e) {
      if (!drag) return;
      var p = pt(e);
      if (drag.type === "move") {
        var s = state.stickers[drag.idx];
        s.x = clamp(p[0] + drag.dx, 0, 400); s.y = clamp(p[1] + drag.dy, 0, 400);
        drag.el.setAttribute("transform", stickerTransform(s));
        if (drag.ring) { drag.ring.setAttribute("cx", s.x); drag.ring.setAttribute("cy", s.y); }
      } else if (drag.type === "draw") {
        var last = drag.pts[drag.pts.length - 1];
        if (Math.abs(last[0] - p[0]) + Math.abs(last[1] - p[1]) < 2 || drag.pts.length >= MAX_PTS) return;
        drag.pts.push(p);
        drag.el.setAttribute("d", pathD(drag.pts));
      } else if (drag.type === "erase") eraseAt(p);
    });
    function end() {
      if (!drag) return;
      var d = drag; drag = null;
      if (d.type === "draw") state.strokes.push({ color: ui.color, w: strokeWidth(), pts: d.pts.map(function (q) { return [Math.round(q[0] * 10) / 10, Math.round(q[1] * 10) / 10]; }) });
      updateArt();
      if (d.type === "draw") renderPanel(); // enables Undo / Clear
    }
    artEl.addEventListener("pointerup", end);
    artEl.addEventListener("pointercancel", end);
    artEl.addEventListener("keydown", function (e) {
      var s = state.stickers[ui.sel];
      if (!s) return;
      var step = e.shiftKey ? 20 : 5, k = e.key;
      if (k === "ArrowLeft") s.x = clamp(s.x - step, 0, 400);
      else if (k === "ArrowRight") s.x = clamp(s.x + step, 0, 400);
      else if (k === "ArrowUp") s.y = clamp(s.y - step, 0, 400);
      else if (k === "ArrowDown") s.y = clamp(s.y + step, 0, 400);
      else if (k === "Delete" || k === "Backspace") { state.stickers.splice(ui.sel, 1); ui.sel = -1; updateArt(); renderPanel(); e.preventDefault(); return; }
      else if (k === "Escape") { select(-1); return; }
      else return;
      e.preventDefault();
      updateArt();
    });
  }

  /* ---------- Photos (large phone photos are shrunk to 2000px JPEGs before sending) ---------- */
  function shrink(file) {
    return new Promise(function (resolve) {
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        var w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, 2000 / Math.max(w, h));
        if (k === 1 && file.size < 2.5 * 1024 * 1024) return resolve(file);
        var c = document.createElement("canvas");
        c.width = Math.round(w * k); c.height = Math.round(h * k);
        var ctx = c.getContext("2d");
        ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, c.width, c.height);
        ctx.drawImage(img, 0, 0, c.width, c.height);
        c.toBlob(function (b) {
          resolve(b ? new File([b], file.name.replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg" }) : file);
        }, "image/jpeg", 0.85);
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(null); }; // e.g. HEIC on a desktop browser
      img.src = url;
    });
  }
  function addPhotos(list) {
    var files = Array.prototype.filter.call(list || [], function (f) { return /^image\//.test(f.type) || /\.(heic|heif)$/i.test(f.name); });
    clearError("photos");
    if (!files.length) return;
    var room = MAX_PHOTOS - photos.length;
    if (room <= 0) return showError("photos", "You can add up to " + MAX_PHOTOS + " pictures.");
    if (files.length > room) showError("photos", "Only the first " + room + " picture" + (room > 1 ? "s were" : " was") + " added (up to " + MAX_PHOTOS + ").");
    Promise.all(files.slice(0, room).map(function (f) {
      return shrink(f).then(function (out) {
        if (out) return out;
        // Couldn't preview it here; send the original if it's a sensible size.
        return f.size <= 8 * 1024 * 1024 ? f : null;
      });
    })).then(function (results) {
      results.forEach(function (f, i) {
        if (!f) return showError("photos", '"' + files[i].name + '" couldn\'t be added. Try a JPG or PNG under 8 MB.');
        photos.push({ file: f, url: URL.createObjectURL(f) });
      });
      renderThumbs();
    });
  }
  function renderThumbs() {
    var box = root.querySelector("[data-thumbs]");
    box.innerHTML = photos.map(function (p, i) {
      return '<div class="ds-thumb"><img src="' + p.url + '" alt="' + esc(p.file.name) + '" onerror="this.replaceWith(Object.assign(document.createElement(\'span\'),{textContent:this.alt}))">' +
        '<button type="button" data-remove="' + i + '" aria-label="Remove ' + esc(p.file.name) + '">&times;</button></div>';
    }).join("");
    root.querySelector("[data-drop]").hidden = photos.length >= MAX_PHOTOS;
  }

  /* ---------- Mockup image (PNG sent with the submission) ---------- */
  function makeMockup() {
    return new Promise(function (resolve) {
      var W = 1000, H = 1200, c = document.createElement("canvas");
      c.width = W; c.height = H;
      var ctx = c.getContext("2d"), kit = kitById(state.kit);
      var CX = 500, CY = 470, R = 384, K = (R * 2) / 400; // svg units -> canvas px
      var img = new Image();
      var draw = function () {
        ctx.fillStyle = "#f5f9fb"; ctx.fillRect(0, 0, W, H);
        ctx.fillStyle = "#22607f"; ctx.beginPath(); ctx.arc(CX, CY, R + 26, 0, Math.PI * 2); ctx.fill();
        ctx.fillStyle = "#ffffff"; ctx.beginPath(); ctx.arc(CX, CY, R, 0, Math.PI * 2); ctx.fill();
        ctx.save(); ctx.beginPath(); ctx.arc(CX, CY, R, 0, Math.PI * 2); ctx.clip();
        ctx.drawImage(img, CX - R, CY - R, R * 2, R * 2);
        // Words use web fonts, which an SVG image can't load, so they're drawn here instead.
        state.stickers.forEach(function (st) {
          if (st.type !== "text") return;
          var f = FONTS[st.font] || FONTS.script;
          ctx.save();
          ctx.translate(CX - R + st.x * K, CY - R + st.y * K);
          ctx.rotate(st.r * Math.PI / 180);
          ctx.scale(st.s * K, st.s * K);
          ctx.font = f[2] + " 14px " + f[1];
          ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.fillStyle = st.color;
          ctx.fillText(st.value, 0, 0);
          ctx.restore();
        });
        ctx.restore();
        ctx.textAlign = "center"; ctx.fillStyle = "#123447";
        ctx.font = "600 56px Fredoka, Nunito, sans-serif";
        ctx.fillText((state.name.trim() || "My " + kit.label.toLowerCase()).slice(0, 40), 500, 975);
        ctx.fillStyle = "#587586"; ctx.font = "700 30px Nunito, sans-serif";
        ctx.fillText([kit.label].concat(state.occasions).join(" · ").slice(0, 70), 500, 1025);
        state.colors.forEach(function (col, i) {
          ctx.fillStyle = col; ctx.strokeStyle = "#d9e4ea"; ctx.lineWidth = 3;
          ctx.beginPath(); ctx.arc(440 + i * 60, 1085, 22, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
        });
        ctx.fillStyle = "#628da6"; ctx.font = "700 24px Nunito, sans-serif";
        ctx.fillText(paletteName() + "  ·  GleamCanvas Design Studio", 500, 1160);
        c.toBlob(resolve, "image/png");
      };
      img.onload = function () { (document.fonts ? document.fonts.ready : Promise.resolve()).then(draw, draw); };
      img.onerror = function () { resolve(null); };
      img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(drawKit(state.kit, state, "ds-png", { noText: true, sel: -1 }));
    });
  }

  /* ---------- Validation & sending ---------- */
  function showError(field, msg) {
    var p = root.querySelector('[data-error="' + field + '"]'), wrap = root.querySelector('[data-field="' + field + '"]');
    if (p) { p.textContent = msg; p.hidden = false; }
    if (wrap) wrap.classList.add("has-error");
  }
  function clearError(field) {
    var p = root.querySelector('[data-error="' + field + '"]'), wrap = root.querySelector('[data-field="' + field + '"]');
    if (p) p.hidden = true;
    if (wrap) wrap.classList.remove("has-error");
  }
  function validate() {
    var bad = [];
    if (state.idea.trim().length < 10) { showError("idea", "Tell us a little about your design (at least a sentence)."); bad.push("ds-idea"); }
    if (!state.firstName.trim()) { showError("firstName", "Please add your first name."); bad.push("ds-first"); }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(state.email.trim())) { showError("email", "Please add a valid email so we can reach you."); bad.push("ds-email"); }
    if (!form.consent.checked) { showError("consent", "Please tick this box to send your design."); bad.push(null); }
    if (bad.length) {
      var first = root.querySelector(".has-error");
      if (first) first.scrollIntoView({ behavior: "smooth", block: "center" });
      if (bad[0]) setTimeout(function () { document.getElementById(bad[0]).focus({ preventScroll: true }); }, 300);
    }
    return !bad.length;
  }
  function setStatus(html, kind) {
    var s = root.querySelector("[data-status]");
    s.className = "ds-status" + (kind ? " is-" + kind : "");
    s.innerHTML = html;
  }
  function decorationSummary() {
    var counts = {}, words = [], parts = [];
    state.stickers.forEach(function (s) {
      if (s.type === "text") words.push('"' + s.value.trim() + '"');
      else { var l = STK[s.type].label; counts[l] = (counts[l] || 0) + 1; }
    });
    var names = Object.keys(counts);
    if (names.length) parts.push("Stickers: " + names.map(function (k) { return k + (counts[k] > 1 ? " ×" + counts[k] : ""); }).join(", "));
    if (words.length) parts.push("Words: " + words.join(", "));
    if (state.strokes.length) parts.push("Freehand drawing: " + state.strokes.length + " line" + (state.strokes.length > 1 ? "s" : ""));
    if (state.pattern !== "plain") parts.push("Surface pattern: " + labelOf(PATTERNS, state.pattern));
    var scene = [];
    if (state.sky !== "none") scene.push(labelOf(SKIES, state.sky).toLowerCase() + " sky");
    if (state.ground !== "none") scene.push(labelOf(GROUNDS, state.ground).toLowerCase() + " ground");
    if (state.falling !== "none") scene.push(labelOf(FALLING, state.falling).toLowerCase());
    if (scene.length) parts.push("Scene: " + scene.join(", "));
    if (state.mode === "3d") {
      var d3 = state.d3, bits = [];
      if (state.kit === "house") {
        bits.push(labelOf(D3_ROOFS, d3.roof).toLowerCase() + " roof", "width " + Math.round(d3.width * 100) + "%", "depth " + Math.round(d3.depth * 100) + "%", "wall height " + Math.round(d3.height * 100) + "%", d3.windows + " window" + (d3.windows === 1 ? "" : "s") + " per side");
      } else bits.push("size " + Math.round(d3.height * 100) + "%");
      (D3_DETAILS[state.kit] || []).forEach(function (x) { if (d3[x[0]]) bits.push(x[1].toLowerCase()); });
      if (state.kit === "house") D3_PIECES.forEach(function (grp) { grp[1].forEach(function (x) { if (d3[x[0]]) bits.push(x[1].toLowerCase()); }); });
      parts.push("Designed in 3D: " + bits.join(", "));
    }
    return parts.join("\n") || "(none)";
  }

  function onSubmit(e) {
    e.preventDefault();
    setStatus("");
    if (!validate()) return;
    if (form.website.value) return done(null); // bots fill the hidden field
    if (!cfg.formId && cfg.mode !== "preview") return setStatus("Design submissions aren't open yet. Please check back soon.", "error");
    if (ui.sel > -1) select(-1);

    var btn = form.querySelector(".ds-submit");
    btn.disabled = true;
    btn.lastChild.textContent = cfg.formId ? "Sending your design…" : "Preparing…";

    var model3d = state.mode === "3d" && viewer ? viewer.snapshot(1000).catch(function () { return null; }) : Promise.resolve(null);
    Promise.all([makeMockup(), model3d]).then(function (pics) {
      var png = pics[0], png3d = pics[1], shown = png3d || png;
      if (!cfg.formId) return shown; // preview mode: nothing is sent
      var total = photos.reduce(function (n, p) { return n + p.file.size; }, (png ? png.size : 0) + (png3d ? png3d.size : 0));
      if (total > MAX_TOTAL) throw new Error("Your pictures are too large to send together. Please remove one and try again.");
      var kit = kitById(state.kit), fd = new FormData();
      fd.append("fi-sender-firstName", state.firstName.trim());
      fd.append("fi-sender-email", state.email.trim());
      fd.append("fi-text-designName", state.name.trim() || "(untitled)");
      fd.append("fi-text-kitType", kit.label);
      fd.append("fi-text-occasion", state.occasions.join(", ") || "(none chosen)");
      fd.append("fi-text-colors", paletteName() + ": main " + state.colors[0] + ", accent " + state.colors[1] + ", trim " + state.colors[2]);
      fd.append("fi-text-extras", state.extras.map(function (id) { return EXTRAS.filter(function (x) { return x.id === id; })[0].label; }).join(", ") || "(none)");
      fd.append("fi-text-decorations", decorationSummary());
      fd.append("fi-text-idea", state.idea.trim());
      fd.append("fi-text-consent", "Agreed: " + cfg.consent);
      if (png) fd.append("fi-file-mockup", png, "design-mockup.png");
      if (png3d) fd.append("fi-file-model3d", png3d, "design-3d-model.png");
      photos.forEach(function (p, i) { fd.append("fi-file-photo" + (i + 1), p.file, p.file.name); });
      // Full design data, so the studio can rebuild or tweak the sketch later.
      var data = designData();
      fd.append("fi-file-designData", new Blob([JSON.stringify(data)], { type: "application/json" }), "design-data.json");

      return fetch(ENDPOINT + encodeURIComponent(cfg.formId), { method: "POST", headers: { Accept: "application/json" }, body: fd })
        .then(function (r) { return r.json().catch(function () { return { success: r.ok }; }); })
        .then(function (res) {
          if (!res || !(res.success === true || res.submission)) throw new Error((res && res.message) || "Something went wrong.");
          return shown;
        });
    }).then(done).catch(function (err) {
      btn.disabled = false;
      btn.lastChild.textContent = "Send my design";
      var msg = err && err.message && !/fetch|network/i.test(err.message) ? err.message : "We couldn't reach our studio. Please check your connection and try again.";
      setStatus("<strong>Your design wasn't sent.</strong> " + esc(msg), "error");
    });
  }

  function done(png) {
    var first = state.firstName.trim();
    clearDraft();
    photos.forEach(function (p) { URL.revokeObjectURL(p.url); });
    photos = [];
    var imgUrl = png ? URL.createObjectURL(png) : "";
    root.innerHTML =
      '<div class="ds-done">' +
        (imgUrl ? '<img src="' + imgUrl + '" alt="Your design mockup" width="1000" height="1200">' : "") +
        '<p class="eyebrow">' + SPARKLE + "Thank you" + (first ? ", " + esc(first) : "") + "</p>" +
        "<h2>" + esc(cfg.thanksHeading) + "</h2>" +
        "<p>" + esc(cfg.thanksText) + "</p>" +
        (!cfg.formId && cfg.mode === "preview" ? '<p class="ds-mode-note"><strong>Preview mode:</strong> nothing was sent. This is what visitors see after sending a design.</p>' : "") +
        '<div class="ds-done-actions">' +
          '<button class="btn btn-primary" type="button" data-again>Design another</button>' +
          (cloudStatus() && cloudStatus().mode !== "off" ? '<button class="btn btn-outline" type="button" data-cloud="save">Save a copy to my account</button>' : "") +
          (imgUrl ? '<a class="btn btn-outline" href="' + imgUrl + '" download="my-gleamcanvas-design.png">Save my mockup</a>' : "") +
          (cfg.community ? '<a class="btn btn-outline" href="' + esc(cfg.community) + '" target="_blank" rel="noopener">Join our design circle</a>' : "") +
        "</div>" +
      "</div>";
    root.querySelector("[data-again]").addEventListener("click", function () {
      state.name = ""; state.idea = ""; state.stickers = []; state.strokes = []; ui.sel = -1; ui.tab = "stickers";
      render();
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    root.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  /* ---------- Draft (so a reload doesn't lose the design; photos aren't kept) ---------- */
  function saveDraft() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () { try { localStorage.setItem(DRAFT_KEY, JSON.stringify(state)); } catch (e) {} }, 250);
  }
  function clearDraft() { clearTimeout(saveTimer); try { localStorage.removeItem(DRAFT_KEY); } catch (e) {} }
  var HEX = /^#[0-9a-f]{6}$/i;
  var FRESH = JSON.parse(JSON.stringify(state)); // a blank design, for opening a customer's file
  // Copy a saved design (draft or design-data.json) into state, keeping only known, sensible values
  function restore(saved) {
    if (saved && typeof saved === "object") {
      Object.keys(state).forEach(function (k) {
        if (saved[k] != null && typeof saved[k] === typeof state[k] && Array.isArray(saved[k]) === Array.isArray(state[k])) state[k] = saved[k];
      });
      if (!KITS.some(function (k) { return k.id === state.kit; })) state.kit = "house";
      if (state.colors.length !== 3 || !state.colors.every(function (c) { return HEX.test(c); })) { state.colors = PALETTES[0].c.slice(); state.palette = "winter"; }
      state.occasions = state.occasions.filter(function (o) { return OCCASIONS.indexOf(o) > -1; });
      state.extras = state.extras.filter(function (id) { return EXTRAS.some(function (x) { return x.id === id; }); });
      [["pattern", PATTERNS, "plain"], ["sky", SKIES, "none"], ["ground", GROUNDS, "none"], ["falling", FALLING, "none"]].forEach(function (f) {
        if (!f[1].some(function (o) { return o[0] === state[f[0]]; })) state[f[0]] = f[2];
      });
      state.stickers = state.stickers.filter(function (s) {
        return s && typeof s === "object" && (STK[s.type] || (s.type === "text" && typeof s.value === "string" && s.value.trim())) &&
          isFinite(s.x) && isFinite(s.y) && isFinite(s.s) && isFinite(s.r) && HEX.test(s.color);
      }).slice(0, MAX_STICKERS).map(function (s) {
        var o = { type: s.type, x: clamp(+s.x, 0, 400), y: clamp(+s.y, 0, 400), s: clamp(+s.s, 0.5, 6), r: +s.r % 360, flip: !!s.flip, color: s.color };
        if (s.type === "text") { o.value = s.value.slice(0, MAX_TEXT); o.font = FONTS[s.font] ? s.font : "script"; }
        return o;
      });
      state.strokes = state.strokes.filter(function (k) {
        return k && typeof k === "object" && HEX.test(k.color) && SIZES.some(function (z) { return z[2] === k.w; }) && Array.isArray(k.pts);
      }).slice(0, MAX_STROKES).map(function (k) {
        return { color: k.color, w: k.w, pts: k.pts.filter(function (p) { return Array.isArray(p) && isFinite(p[0]) && isFinite(p[1]); }).slice(0, MAX_PTS).map(function (p) { return [clamp(+p[0], -20, 420), clamp(+p[1], -20, 420)]; }) };
      }).filter(function (k) { return k.pts.length; });
      // 3D settings: keep only known keys with sensible values
      if (state.mode !== "3d") state.mode = "2d";
      var d3 = JSON.parse(JSON.stringify(D3_DEFAULTS)), saved3 = state.d3 && typeof state.d3 === "object" ? state.d3 : {};
      Object.keys(d3).forEach(function (k) {
        var v = saved3[k];
        if (typeof d3[k] === "boolean" && typeof v === "boolean") d3[k] = v;
        else if (k === "roof" && D3_ROOFS.some(function (r) { return r[0] === v; })) d3.roof = v;
        else if (k === "windows" && [0, 1, 2, 3].indexOf(v) > -1) d3.windows = v;
        else if (["width", "depth", "height"].indexOf(k) > -1 && isFinite(v)) d3[k] = clamp(+v, 0.7, 1.5);
      });
      state.d3 = d3;
    }
  }
  try { restore(JSON.parse(localStorage.getItem(DRAFT_KEY) || "null")); } catch (e) {}

  // Colors sent from the Palette Mood Boards (…?colors=rrggbb,rrggbb,rrggbb) override the draft's colors.
  try {
    var linked = (new URLSearchParams(location.search).get("colors") || "").split(",").map(function (c) { return "#" + c.trim().toLowerCase(); });
    if (linked.length === 3 && linked.every(function (c) { return HEX.test(c); })) { state.colors = linked; state.palette = "custom"; }
  } catch (e) {}

  render();

  /* ---------- Store owner: reopen a submitted design (…/design-with-us#open-design) ---------- */
  // Each submission includes design-data.json. Opening it here shows the exact design,
  // including the 3D model you can turn around. Nothing is sent.
  if (location.hash === "#open-design") {
    var bar = document.createElement("div");
    bar.className = "ds-opener";
    bar.innerHTML = '<div><strong>Open a customer&rsquo;s design</strong><span>Choose the <code>design-data.json</code> file from a submission. The design opens below, so you can turn the 3D model around. Nothing is sent.</span></div>' +
      '<label class="btn btn-primary btn-sm ds-opener-btn">Choose file<input type="file" accept=".json,application/json"></label><p class="ds-opener-msg" role="status"></p>';
    root.parentNode.insertBefore(bar, root);
    var msg = bar.querySelector(".ds-opener-msg");
    bar.querySelector("input").addEventListener("change", function (e) {
      var file = e.target.files[0];
      e.target.value = "";
      if (!file) return;
      file.text().then(function (txt) {
        var data = JSON.parse(txt);
        Object.keys(FRESH).forEach(function (k) { state[k] = JSON.parse(JSON.stringify(FRESH[k])); });
        restore(data);
        ui.sel = -1; ui.tab = state.mode === "3d" ? "shape" : "stickers";
        render();
        msg.textContent = "Opened " + file.name + ": " + kitById(state.kit).label + (state.mode === "3d" ? " in 3D" : " (2D sketch)") + ".";
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      }).catch(function () { msg.textContent = "That file couldn't be opened. Please choose the design-data.json file from a submission."; });
    });
  }
})();
